import React, { useState, useEffect, useRef, useCallback } from 'react';
import EmojiPicker from '@emoji-mart/react';
import emojiData from '@emoji-mart/data';


const WaIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="#22c55e"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
const IgIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="5" fill="url(#ig)" /><circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.5" fill="none"/><circle cx="17.5" cy="6.5" r="1" fill="#fff"/><defs><linearGradient id="ig" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse"><stop stopColor="#f9ce34"/><stop offset="0.3" stopColor="#ee2a7b"/><stop offset="1" stopColor="#6228d7"/></linearGradient></defs></svg>;
const FbIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="#1877f2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>;

const initials = (name) => (name||'?').split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase();
const AVATAR_COLORS = ['#6ee7b7','#93c5fd','#fca5a5','#fcd34d','#c4b5fd','#86efac','#fdba74','#67e8f9'];

const fmtTime = (ts) => {
  if (!ts) return '';
  try {
    const s = String(ts).replace(' ', 'T');
    const d = new Date(s.includes('+') || s.includes('Z') ? s : s + '-05:00');
    return d.toLocaleTimeString('es-CO', {hour:'2-digit', minute:'2-digit'});
  } catch(e) { return ''; }
};

const fmtCOP = (v) => v > 0 ? new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(v) : '—';

const API = 'https://talku.online';
const AGENTES = ['Daniel','Tatiana Rojas','Paola Escobar','Oficina Trend','Soporte'];

const FLOWS_ACTIVOS = [
  { id:1,  tipo:'webhook', nombre:'TCF CONFIRMACION',          tienda:'Tiendas Colombia', ejecuciones:1842, estado:'activo',   mensaje:'Hola {nombre}, tu pedido ha sido confirmado. En breve recibirás más detalles. 📦' },
  { id:3,  tipo:'http',    nombre:'Novedad CM: NO SE LOCALIZÓ', tienda:'Tiendas Colombia', ejecuciones:324,  estado:'activo',   mensaje:'Hola {nombre}, tuvimos un inconveniente localizando tu dirección. ¿Puedes confirmarnos tu dirección completa?' },
  { id:4,  tipo:'http',    nombre:'Novedad CM: NO SE LOCALIZÓ 2',tienda:'Coordinadora',   ejecuciones:210,  estado:'activo',   mensaje:'Hola {nombre}, tuvimos un inconveniente localizando tu dirección. ¿Puedes confirmarnos tu dirección completa con barrio y ciudad?' },
  { id:5,  tipo:'http',    nombre:'Novedad CM: REPARTO',        tienda:'Coordinadora',     ejecuciones:890,  estado:'activo',   mensaje:'Hola {nombre}, tu pedido ya está en reparto. Lo recibirás hoy o mañana. 🚚' },
  { id:2,  tipo:'http',    nombre:'Novedad CM: ENTREGADO',      tienda:'Tiendas Colombia', ejecuciones:0,    estado:'inactivo', mensaje:'Hola {nombre}, tu pedido ha sido entregado. ¡Esperamos que estés feliz con tu compra! 😊' },
  { id:8,  tipo:'instagram',nombre:'Instagram: Tiendas Col...',  tienda:'Tiendas Colombia', ejecuciones:312,  estado:'activo',   mensaje:'¡Hola! Gracias por contactarnos. ¿En qué podemos ayudarte hoy?' },
  { id:10, tipo:'messenger',nombre:'Messenger: Tiendas C...',   tienda:'Tiendas Colombia', ejecuciones:428,  estado:'activo',   mensaje:'Hola, gracias por escribirnos. Un agente te atenderá en breve.' },
  { id:11, tipo:'webhook', nombre:'Preliminares T-CO 2',        tienda:'Tiendas Colombia', ejecuciones:654,  estado:'activo',   mensaje:'Hola {nombre}, notamos que iniciaste un pedido. ¿Te ayudamos a completarlo?' },
  { id:6,  tipo:'whatsapp',nombre:'Pedido preliminar COD',      tienda:'Tiendas Colombia', ejecuciones:0,    estado:'inactivo', mensaje:'Hola {nombre}, vimos que intentaste hacer un pedido. ¿Te ayudamos a completarlo? Es fácil y rápido 🛍️' },
  { id:12, tipo:'webhook', nombre:'Carrito abandonado',         tienda:'Tiendas Colombia', ejecuciones:0,    estado:'inactivo', mensaje:'Hola {nombre}, dejaste productos en tu carrito. ¿Quieres que te ayudemos a completar tu pedido?' },
];

const FLOW_TIPO_COLOR = { webhook:'#8b5cf6', http:'#3b82f6', whatsapp:'#22c55e', instagram:'#ee2a7b', messenger:'#1877f2', shopify:'#5a8a00' };

const PLANTILLAS_INTERNAS = [
  { id:'p1', nombre:'Seguimiento de pedido', categoria:'servicio', texto:'Hola {nombre}, te informamos que tu pedido #{orden} está {estado}. Para más información escríbenos.' },
  { id:'p2', nombre:'Solicitud de dirección', categoria:'logística', texto:'Hola {nombre}, necesitamos confirmar tu dirección de entrega. ¿Podrías enviárnosla completa con barrio y ciudad?' },
  { id:'p3', nombre:'Cambio de talla', categoria:'garantías', texto:'Hola {nombre}, para procesar tu cambio de talla necesitamos que nos indiques: 1️⃣ Talla actual recibida 2️⃣ Talla que deseas 3️⃣ Foto del producto' },
  { id:'p4', nombre:'Pedido entregado', categoria:'post-venta', texto:'Hola {nombre}, ¿recibiste tu pedido? Esperamos que estés feliz con tu compra. 😊 Si tienes alguna novedad, con gusto te ayudamos.' },
  { id:'p5', nombre:'Producto agotado alternativa', categoria:'ventas', texto:'Hola {nombre}, lamentamos informarte que el producto que buscas está siendo reabastecido. Te ofrecemos estas alternativas: [agregar productos]' },
  { id:'p6', nombre:'Confirmación devolución', categoria:'garantías', texto:'Hola {nombre}, recibimos tu solicitud de devolución. En 24-48 horas hábiles procesaremos tu caso. Gracias por tu paciencia.' },
];

const NOVEDAD_COLORS = {
  'En reparto': '#3b82f6', 'Entregado': '#16a34a', 'En tránsito': '#f59e0b',
  'Llegó a ciudad destino': '#16a34a', 'Dirección incorrecta': '#ef4444',
};

const MOCK_CONVS = [
  { id:'mock_1', contact_name:'Valentina Morales', contact_phone:'573001234567', channel:'instagram', last_message:'Hola! vi sus zapatos en instagram y me encantaron 😍 ¿Tienen envío a Medellín?', last_message_at: new Date(Date.now()-4*60000).toISOString(), unread_count:2, status:'open' },
  { id:'mock_2', contact_name:'Camilo Herrera',    contact_phone:'573109876543', channel:'messenger',  last_message:'Quisiera saber los precios de la nueva colección', last_message_at: new Date(Date.now()-35*60000).toISOString(), unread_count:0, status:'open' },
  { id:'mock_3', contact_name:'Isabella Castro',   contact_phone:'573207654321', channel:'instagram', last_message:'Ya hice el pedido, cuánto demora el envío?', last_message_at: new Date(Date.now()-2*3600000).toISOString(), unread_count:0, status:'open' },
];

const MOCK_MSGS = [
  { id:1, role:'inbound',  content:'Hola! vi sus zapatos en instagram y me encantaron 😍', sent_at: new Date(Date.now()-10*60000).toISOString(), status:'read', source:'customer' },
  { id:2, role:'inbound',  content:'¿Tienen envío a Medellín? y cuánto demora?', sent_at: new Date(Date.now()-9*60000).toISOString(), status:'read', source:'customer' },
  { id:3, role:'outbound', content:'Hola Valentina! Claro que sí, hacemos envíos a toda Colombia 🇨🇴 El tiempo de entrega es de 2 a 4 días hábiles y el envío es completamente gratis.', sent_at: new Date(Date.now()-8*60000).toISOString(), status:'read', source:'agent' },
  { id:4, role:'inbound',  content:'Qué bueno! ¿Y qué tallas manejan en las botas café que tienen en el perfil?', sent_at: new Date(Date.now()-6*60000).toISOString(), status:'read', source:'customer' },
  { id:5, role:'outbound', content:'Manejamos tallas 35 a 44 en ese modelo. ¿Cuál es tu talla?', sent_at: new Date(Date.now()-5*60000).toISOString(), status:'delivered', source:'agent' },
  { id:6, role:'inbound',  content:'¿Tienen envío a Medellín?', sent_at: new Date(Date.now()-4*60000).toISOString(), status:'read', source:'customer' },
];

const MediaExpired = ({ type }) => (
  <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:'rgba(255,255,255,0.08)',borderRadius:8,fontSize:12,color:'#aaa'}}>
    <span>{type==='audio'?'🎵':type==='video'?'🎬':type==='document'?'📄':'🖼️'}</span>
    <span>Archivo expirado — solo disponible 1h</span>
  </div>
);

export default function SocialInbox({ user }) {
  const [activeNav, setActiveNav] = useState('Conversaciones');
  const [showNotifs, setShowNotifs] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState([]);
  const [activeConv, setActiveConv] = useState(null);
  const [filter, setFilter] = useState('Todos');
  const [searchQuery, setSearchQuery] = useState('');
  const [msgInput, setMsgInput] = useState('');
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMsgs, setLoadingMsgs] = useState(false);
  const [hasMoreMsgs, setHasMoreMsgs] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [notes, setNotes] = useState([]);
  const [noteInput, setNoteInput] = useState('');
  const [activeTab, setActiveTab] = useState('cliente');
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const [showOptionsMenu, setShowOptionsMenu] = useState(false);
  const [showCallMenu, setShowCallMenu] = useState(false);
  const [convStatuses, setConvStatuses] = useState({});
  const [shopifyContact, setShopifyContact] = useState(null);
  const [shopifyOrders, setShopifyOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);
  const [showFlows, setShowFlows] = useState(false);
  const [flowStep, setFlowStep] = useState('list'); // 'list' | 'preview'
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [flowSending, setFlowSending] = useState(false);
  const [flowResult, setFlowResult] = useState(null); // null | 'ok' | 'error'
  const [flowSearch, setFlowSearch] = useState('');
  const [flowFilterEstado, setFlowFilterEstado] = useState('activo');
  const [showOrderSelect, setShowOrderSelect] = useState(false);
  const [showOrderActions, setShowOrderActions] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [showCallIA, setShowCallIA] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [templateSearch, setTemplateSearch] = useState('');
  const [templateTab, setTemplateTab] = useState('meta');
  const [metaTemplates, setMetaTemplates] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [actionMsg, setActionMsg] = useState('');
  const [shopifyNoteInput, setShopifyNoteInput] = useState('');
  const [shopifyTagInput, setShopifyTagInput] = useState('');
  const [recording, setRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [assignedAgent, setAssignedAgent] = useState({});
  const [imgModal, setImgModal] = useState(null);
  const [mediaErrors, setMediaErrors] = useState({});
  const [pendingMedia, setPendingMedia] = useState(null);
  const [sendError, setSendError] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [exitingNotifs, setExitingNotifs] = useState(new Set());
  const [storeDomain, setStoreDomain] = useState('');
  useEffect(() => { const tk = localStorage.getItem('talku_token'); fetch(`${API}/stores/`, { headers: { Authorization: `Bearer ${tk || ''}` } }).then(r=>r.json()).then(d=>{ if (Array.isArray(d) && d.length) setStoreDomain(d[0].domain); }).catch(()=>{}); }, []); // eslint-disable-line

  // Reply con cita
  const [replyTo, setReplyTo] = useState(null); // { id, content, sender, wamid }

  // Emoji picker
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  // Búsqueda global de mensajes
  const [globalResults, setGlobalResults] = useState([]); // [{ conv_id, conv_name, conv_phone, message_id, content, sent_at, role }]
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  const globalSearchTimerRef = useRef(null);

  // Búsqueda interna del chat (Ctrl+F)
  const [showChatSearch, setShowChatSearch] = useState(false);
  const [chatSearchTerm, setChatSearchTerm] = useState('');
  const [chatSearchIdx, setChatSearchIdx] = useState(0);
  const chatSearchRef = useRef(null);
  const msgRefs = useRef({});

  // Panel izquierdo
  const [listTab, setListTab] = useState('nuevos'); // 'nuevos' | 'resueltos'
  const [favConvs, setFavConvs] = useState(() => { try { return new Set(JSON.parse(localStorage.getItem('talku_favs') || '[]')); } catch { return new Set(); } });
  const [convLabels, setConvLabels] = useState(() => { try { return JSON.parse(localStorage.getItem('talku_labels') || '{}'); } catch { return {}; } });
  const [labelFilter, setLabelFilter] = useState(null); // null | 'pedido' | 'novedad' | 'garantia'
  const [showLabelFilter, setShowLabelFilter] = useState(false);
  const [contextMenu, setContextMenu] = useState(null); // { x, y, convId }

  const toggleFav = (convId) => {
    setFavConvs(prev => {
      const next = new Set(prev);
      next.has(convId) ? next.delete(convId) : next.add(convId);
      localStorage.setItem('talku_favs', JSON.stringify([...next]));
      return next;
    });
  };

  const setLabel = (convId, label) => {
    setConvLabels(prev => {
      const next = { ...prev, [convId]: label };
      localStorage.setItem('talku_labels', JSON.stringify(next));
      return next;
    });
    setContextMenu(null);
  };


  const messagesAreaRef = useRef(null);
  const pollRef = useRef(null);
  const optionsRef = useRef(null);
  const fileInputRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recordingTimerRef = useRef(null);
  const recordingCancelledRef = useRef(false);
  const activeConvRef = useRef(null);
  const activePhoneRef = useRef(null);
  const conversationsRef = useRef([]);
  const prevConvsRef = useRef({});
  const notifTimersRef = useRef({});

  const STATUS_OPTIONS = [
    { id:'open', label:'Abierto', color:'#16a34a', bg:'#f0fdf4' },
    { id:'waiting', label:'En espera', color:'#d97706', bg:'#fffbeb' },
    { id:'urgent', label:'Urgente', color:'#ef4444', bg:'#fef2f2' },
    { id:'resolved', label:'Resuelto', color:'#888', bg:'#f4f4f2' },
  ];

  const OPTIONS_MENU = [
    { id:'assign', label:'Asignar conversación', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg> },
    { id:'history', label:'Ver historial completo', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 15"/></svg> },
    { id:'archive', label:'Archivar', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/></svg> },
    { id:'spam', label:'Marcar como spam', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="0.5" fill="#ef4444"/></svg>, danger: true },
  ];

  const handleNav = (id) => { setActiveNav(id); };

  useEffect(() => {
    const close = () => { setContextMenu(null); setShowLabelFilter(false); setShowEmojiPicker(false); };
    window.addEventListener('click', close);
    return () => window.removeEventListener('click', close);
  }, []);

  // Ctrl+F abre búsqueda interna
  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
        e.preventDefault();
        setShowChatSearch(v => { if (!v) setChatSearchTerm(''); return !v; });
        setTimeout(() => chatSearchRef.current?.focus(), 50);
      }
      if (e.key === 'Escape') { setShowChatSearch(false); setChatSearchTerm(''); setShowEmojiPicker(false); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Derived: matching messages for search
  const searchMatches = chatSearchTerm.length >= 2
    ? messages.filter(m => (m.content || '').toLowerCase().includes(chatSearchTerm.toLowerCase()))
    : [];

  const scrollToMatch = useCallback((idx) => {
    const m = searchMatches[idx];
    if (!m) return;
    const el = msgRefs.current[m.id];
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [searchMatches]);

  useEffect(() => {
    setChatSearchIdx(0);
    if (searchMatches.length > 0) scrollToMatch(0);
  }, [chatSearchTerm, searchMatches.length]);

  const goSearchPrev = () => {
    const next = (chatSearchIdx - 1 + searchMatches.length) % searchMatches.length;
    setChatSearchIdx(next);
    scrollToMatch(next);
  };
  const goSearchNext = () => {
    const next = (chatSearchIdx + 1) % searchMatches.length;
    setChatSearchIdx(next);
    scrollToMatch(next);
  };

  // Búsqueda global debounced
  useEffect(() => {
    clearTimeout(globalSearchTimerRef.current);
    if (searchQuery.length < 3) { setGlobalResults([]); return; }
    globalSearchTimerRef.current = setTimeout(async () => {
      setGlobalSearchLoading(true);
      try {
        const res = await fetch(`${API}/whatsapp/search?q=${encodeURIComponent(searchQuery)}`);
        const data = await res.json();
        setGlobalResults(data.results || []);
      } catch(e) { setGlobalResults([]); }
      setGlobalSearchLoading(false);
    }, 350);
    return () => clearTimeout(globalSearchTimerRef.current);
  }, [searchQuery]);

  const highlightText = (text, term) => {
    if (!term || term.length < 2 || !text) return text;
    const parts = text.split(new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));
    return parts.map((part, i) =>
      part.toLowerCase() === term.toLowerCase()
        ? <mark key={i} style={{background:'#fef08a',borderRadius:3,padding:'0 1px',color:'#0a0a0a'}}>{part}</mark>
        : part
    );
  };

  useEffect(() => { activeConvRef.current = activeConv; setReplyTo(null); }, [activeConv]);

  const playNotifSound = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      [[880, 0, 0.15], [1108, 0.12, 0.28]].forEach(([freq, start, end]) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, ctx.currentTime + start);
        gain.gain.linearRampToValueAtTime(0.22, ctx.currentTime + start + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + end);
        osc.start(ctx.currentTime + start);
        osc.stop(ctx.currentTime + end);
      });
    } catch(e) {}
  };

  const loadConversations = async () => {
    try {
      const res = await fetch(`${API}/whatsapp/conversations`);
      const data = await res.json();
      if (data.conversations) {
        const isFirstLoad = Object.keys(prevConvsRef.current).length === 0;
        if (!isFirstLoad) {
          data.conversations.forEach(conv => {
            const prevCount = prevConvsRef.current[conv.id] || 0;
            if ((conv.unread_count || 0) > prevCount && conv.id !== activeConvRef.current) {
              const notifId = `notif_${conv.id}`;
              setNotifications(prev => {
                const filtered = prev.filter(n => n.convId !== conv.id);
                return [...filtered, { id: notifId, convId: conv.id, contactName: conv.contact_name || conv.contact_phone, message: conv.last_message || '', channel: conv.channel || 'wa', timestamp: conv.last_message_at }];
              });
              playNotifSound();
              clearTimeout(notifTimersRef.current[conv.id]);
              notifTimersRef.current[conv.id] = setTimeout(() => dismissNotification(notifId), 6000);
            }
          });
        }
        data.conversations.forEach(c => { prevConvsRef.current[c.id] = c.unread_count || 0; });
        const social = data.conversations.filter(c => ['instagram','messenger','tiktok'].includes(c.channel || ''));
        setConversations(social);
        if (!activeConvRef.current && data.conversations.length > 0) setActiveConv(data.conversations[0].id);
      }
    } catch (e) {}
    setLoading(false);
  };

  const loadMessages = async (convId, silent = false) => {
    if (!convId) return;
    if (String(convId).startsWith('mock_')) return;
    if (!silent) setLoadingMsgs(true);
    try {
      const res = await fetch(`${API}/whatsapp/conversations/${convId}/messages?limit=50`);
      const data = await res.json();
      if (data.messages) {
        setHasMoreMsgs(!!data.has_more);
        setMessages(prev => {
          const temps = prev.filter(m => {
            if (!String(m.id).startsWith('temp_')) return false;
            if (m.media_type) return !data.messages.some(db => db.role === 'outbound' && db.media_type === m.media_type);
            return !data.messages.some(db => db.role === 'outbound' && db.content === m.content);
          });
          const prevStr = JSON.stringify(prev.filter(m => !String(m.id).startsWith('temp_')).map(m => m.id + m.status));
          const newStr = JSON.stringify(data.messages.map(m => m.id + m.status));
          if (prevStr === newStr && temps.length === 0) return prev;
          return [...data.messages, ...temps].sort((a, b) => {
            const idA = String(a.id).startsWith('temp_') ? 999999999 : Number(a.id);
            const idB = String(b.id).startsWith('temp_') ? 999999999 : Number(b.id);
            return idA - idB;
          });
        });
      }
    } catch (e) {}
    if (!silent) setLoadingMsgs(false);
  };

  const loadMoreMessages = async () => {
    if (!activeConv || loadingMore) return;
    const firstId = messages.find(m => !String(m.id).startsWith('temp_'))?.id;
    if (!firstId) return;
    setLoadingMore(true);
    try {
      const res = await fetch(`${API}/whatsapp/conversations/${activeConv}/messages?limit=50&before_id=${firstId}`);
      const data = await res.json();
      if (data.messages && data.messages.length > 0) {
        setHasMoreMsgs(!!data.has_more);
        const area = messagesAreaRef.current;
        const prevScrollHeight = area?.scrollHeight || 0;
        setMessages(prev => {
          const existingIds = new Set(prev.map(m => m.id));
          const newMsgs = data.messages.filter(m => !existingIds.has(m.id));
          return [...newMsgs, ...prev].sort((a, b) => {
            const idA = String(a.id).startsWith('temp_') ? 999999999 : Number(a.id);
            const idB = String(b.id).startsWith('temp_') ? 999999999 : Number(b.id);
            return idA - idB;
          });
        });
        // Mantener posición de scroll después de insertar mensajes arriba
        setTimeout(() => {
          if (area) area.scrollTop = area.scrollHeight - prevScrollHeight;
        }, 0);
      } else {
        setHasMoreMsgs(false);
      }
    } catch(e) {}
    setLoadingMore(false);
  };

  const loadShopifyData = async (phone) => {
    if (!phone) return;
    const rawPhone = phone.replace(/\D/g, '');
    try {
      const res = await fetch(`${API}/contacts/by-phone/${rawPhone}`);
      const d = await res.json();
      if (d.found) {
        setShopifyContact(d);
        setLoadingOrders(true);
        const ores = await fetch(`${API}/contacts/${d.id}/orders`);
        const odata = await ores.json();
        const orders = (odata.orders || []).slice(0, 8).map(o => ({
          shopify_id: o.id, id: o.name,
          status: o.fulfillment_status === 'fulfilled' ? 'Entregado' : o.financial_status === 'paid' ? 'Pagado' : 'Pendiente',
          fulfillment_status: o.fulfillment_status, financial_status: o.financial_status,
          product: o.line_items?.[0]?.name || 'Producto', variant: o.line_items?.[0]?.variant_title || '',
          total: parseFloat(o.total_price || 0), guia: o.fulfillments?.[0]?.tracking_number || null,
          transportadora: o.fulfillments?.[0]?.tracking_company || null, date: o.created_at,
          tags: o.tags || '', note: o.note || '',
        }));
        setShopifyOrders(orders);
        setLoadingOrders(false);
      } else {
        setShopifyContact(null);
        setShopifyOrders([]);
      }
    } catch (e) { setLoadingOrders(false); }
  };

  const loadMetaTemplates = async () => {
    try {
      const res = await fetch(`${API}/whatsapp/templates`);
      const data = await res.json();
      setMetaTemplates(data.data || data.templates || []);
    } catch (e) {}
  };

  const dismissNotification = (id) => {
    setExitingNotifs(prev => new Set([...prev, id]));
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
      setExitingNotifs(prev => { const s = new Set([...prev]); s.delete(id); return s; });
    }, 380);
  };

  const replyNotification = (notif) => {
    setActiveConv(notif.convId);
    markRead(notif.convId);
    dismissNotification(notif.id);
  };

  const markRead = async (convId) => {
    try {
      await fetch(`${API}/whatsapp/conversations/${convId}/mark-read`, { method: 'POST' });
      setConversations(prev => prev.map(c => c.id === convId ? { ...c, unread_count: 0 } : c));
      dismissNotification(`notif_${convId}`);
    } catch (e) {}
  };

  useEffect(() => { conversationsRef.current = conversations; }, [conversations]);

  useEffect(() => {
    loadConversations();
    pollRef.current = setInterval(loadConversations, 5000);
    const msgPoll = setInterval(() => {
      if (activeConvRef.current) {
        loadMessages(activeConvRef.current, true);
        const conv = conversationsRef.current.find(c => c.id === activeConvRef.current);
        if (conv?.unread_count > 0) markRead(activeConvRef.current);
      }
    }, 2000);
    return () => { clearInterval(pollRef.current); clearInterval(msgPoll); };
  }, []);

  useEffect(() => {
    if (activeConv) {
      loadMessages(activeConv);
      setMediaErrors({});
      activePhoneRef.current = null;
      setPendingMedia(null);
      setSendError('');
    }
  }, [activeConv]);

  useEffect(() => {
    if (activeConv && conversations.length > 0) {
      const c = conversations.find(x => x.id === activeConv);
      if (c?.contact_phone && c.contact_phone !== activePhoneRef.current) {
        activePhoneRef.current = c.contact_phone;
        loadShopifyData(c.contact_phone);
      }
    }
  }, [activeConv, conversations]);

  useEffect(() => {
    if (messagesAreaRef.current) {
      messagesAreaRef.current.scrollTop = messagesAreaRef.current.scrollHeight;
    }
  }, [messages.length]);

  useEffect(() => {
    const handleClick = (e) => {
      if (optionsRef.current && !optionsRef.current.contains(e.target)) setShowOptionsMenu(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const sendMessage = async (text) => {
    const msg = text || msgInput;
    if (!msg.trim() || !activeConv) return;
    const conv = conversations.find(c => c.id === activeConv);
    if (!conv) return;
    const currentReplyTo = replyTo;
    setReplyTo(null);
    const tempMsg = { id: 'temp_' + Date.now(), role: 'outbound', content: msg, sent_at: new Date().toISOString(), status: 'sent', source: 'agent', quoted_content: currentReplyTo?.content || null, quoted_sender: currentReplyTo?.sender || null };
    setMessages(prev => {
      const all = [...prev, tempMsg];
      return all.sort((a, b) => {
        const idA = String(a.id).startsWith('temp_') ? 999999999 : Number(a.id);
        const idB = String(b.id).startsWith('temp_') ? 999999999 : Number(b.id);
        return idA - idB;
      });
    });
    if (!text) setMsgInput('');
    setSending(true);
    try {
      await fetch(`${API}/whatsapp/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone: conv.contact_phone,
          message: msg,
          source: 'agent',
          ...(currentReplyTo ? {
            context_message_id: currentReplyTo.wamid || '',
            quoted_content: currentReplyTo.content || '',
            quoted_sender: currentReplyTo.sender || '',
          } : {})
        })
      });
    } catch (e) {}
    setSending(false);
  };

  const sendMedia = async (file) => {
    const conv = conversations.find(c => c.id === activeConv);
    if (!conv || !file) return;
    const MB5 = 5 * 1024 * 1024;
    const MB100 = 100 * 1024 * 1024;
    const isImage = file.type.startsWith('image/');
    const maxSize = isImage ? MB5 : MB100;
    if (file.size > maxSize) {
      setSendError(`Archivo muy grande (${(file.size/1024/1024).toFixed(1)}MB). Máximo: ${isImage?'5':'100'}MB`);
      return;
    }
    setSending(true);
    setSendError('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      const uploadRes = await fetch(`${API}/whatsapp/upload-media`, { method: 'POST', body: formData });
      const uploadData = await uploadRes.json();
      if (!uploadData.id) {
        const errDetail = uploadData.error?.message || uploadData.message || uploadData.error_data?.details || JSON.stringify(uploadData).slice(0,120);
        setSendError(`Error al subir: ${errDetail}`);
        setSending(false);
        return;
      }
      const type = file.type.startsWith('image/') ? 'image' : file.type.startsWith('video/') ? 'video' : file.type.startsWith('audio/') ? 'audio' : 'document';
      const sendRes = await fetch(`${API}/whatsapp/send-media`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: conv.contact_phone, type, media_id: uploadData.id, filename: file.name, local_url: uploadData.local_url || '' })
      });
      const sendData = await sendRes.json();
      if (sendData.error) {
        setSendError(`Error al enviar: ${sendData.error?.message || JSON.stringify(sendData.error).slice(0,120)}`);
      }
      const contentLabel = type === 'image' ? '[Imagen]' : type === 'video' ? '[Video]' : type === 'audio' ? '[Audio]' : `[Documento: ${file.name}]`;
      const tempMedia = { id: 'temp_' + Date.now(), role: 'outbound', content: contentLabel, sent_at: new Date().toISOString(), status: 'sent', source: 'agent', media_type: type, media_url: uploadData.local_url || null };
      setMessages(prev => [...prev, tempMedia]);
    } catch (e) {
      setSendError(`Error: ${e.message}`);
    }
    setSending(false);
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus'
                     : MediaRecorder.isTypeSupported('audio/ogg;codecs=opus') ? 'audio/ogg;codecs=opus'
                     : 'audio/webm';
      const mediaRecorder = new MediaRecorder(stream, { mimeType });
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];
      recordingCancelledRef.current = false;
      mediaRecorder.ondataavailable = e => audioChunksRef.current.push(e.data);
      mediaRecorder.onstop = async () => {
        stream.getTracks().forEach(t => t.stop());
        if (recordingCancelledRef.current) return;
        const ext = mimeType.includes('mp4') ? 'm4a' : mimeType.includes('ogg') ? 'ogg' : 'webm';
        const baseMime = mimeType.split(';')[0];
        const blob = new Blob(audioChunksRef.current, { type: mimeType });
        const file = new File([blob], `nota_voz.${ext}`, { type: baseMime });
        await sendMedia(file);
      };
      mediaRecorder.start();
      setRecording(true);
      setRecordingTime(0);
      recordingTimerRef.current = setInterval(() => setRecordingTime(t => t + 1), 1000);
    } catch (e) { alert('No se pudo acceder al micrófono'); }
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setRecording(false);
    clearInterval(recordingTimerRef.current);
    setRecordingTime(0);
  };

  const shopifyAction = async (action, orderId, extra = {}) => {
    setActionLoading(true); setActionMsg('');
    try {
      let url, body = {};
      if (action === 'cancel') { url = `${API}/orders/${orderId}/cancel`; }
      else if (action === 'note') { url = `${API}/orders/${orderId}/note`; body = { note: extra.note }; }
      else if (action === 'tags') { url = `${API}/orders/${orderId}/tags`; body = { tags: extra.tags }; }
      else if (action === 'fulfill') { url = `${API}/orders/${orderId}/fulfill`; }
      else if (action === 'mark-paid') { url = `${API}/orders/${orderId}/mark-paid`; }
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (res.ok) { setActionMsg('✅ Acción realizada correctamente'); const c = conversations.find(x => x.id === activeConv); if (c?.contact_phone) loadShopifyData(c.contact_phone); }
      else { setActionMsg('❌ Error al realizar la acción'); }
    } catch (e) { setActionMsg('❌ Error de conexión'); }
    setActionLoading(false);
  };

  const conv = conversations.find(c => c.id === activeConv);
  const currentStatus = convStatuses[activeConv] || conv?.status || 'open';
  const statusObj = STATUS_OPTIONS.find(s => s.id === currentStatus) || STATUS_OPTIONS[0];
  const filtered = conversations.filter(c => {
    const q = searchQuery.trim().toLowerCase();
    const matchesSearch = !q ||
      (c.contact_name || '').toLowerCase().includes(q) ||
      (c.contact_phone || '').includes(q) ||
      (c.last_message || '').toLowerCase().includes(q);
    if (!matchesSearch) return false;
    if (filter === 'Nuevos') return (c.unread_count || 0) > 0;
    if (filter === 'Abiertos') return c.status === 'open';
    if (filter === 'Urgentes') return c.status === 'urgent';
    if (filter === 'Resueltos') return c.status === 'resolved';
    return true;
  });

  const activeOrder = shopifyOrders.find(o => o.fulfillment_status !== 'fulfilled') || shopifyOrders[0];
  const pastOrders = shopifyOrders.filter(o => o.shopify_id !== activeOrder?.shopify_id);
  const novedades = activeOrder?.guia ? [
    { time: 'Hoy 08:15', title: 'En reparto', desc: 'Salió del CD · ' + (activeOrder.transportadora || 'Coordinadora') },
    { time: 'Ayer 18:30', title: 'Llegó a ciudad destino', desc: 'Paquete en bodega destino' },
    { time: 'Ayer 09:00', title: 'En tránsito', desc: 'Salió de bodega Cúcuta' },
  ] : [];

  const ChannelIcon = ({ ch }) => (ch === 'instagram' || ch === 'ig') ? <IgIcon /> : <FbIcon />;
  const fmtRecording = (s) => `${Math.floor(s/60).toString().padStart(2,'0')}:${(s%60).toString().padStart(2,'0')}`;
  const isOrderEditable = (order) => order && order.fulfillment_status !== 'fulfilled';

  const SourceBadge = ({ source, isOut }) => {
    if (!isOut) return null;
    if (source === 'bot') return <span style={{display:'inline-flex',alignItems:'center',gap:3,background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:6,padding:'1px 6px',fontSize:9,color:'#3b82f6',fontWeight:700}}><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M12 11V7"/><circle cx="12" cy="5" r="2"/></svg>IA</span>;
    if (source === 'flow') return <span style={{display:'inline-flex',alignItems:'center',gap:3,background:'#fdf4ff',border:'1px solid #e9d5ff',borderRadius:6,padding:'1px 6px',fontSize:9,color:'#9333ea',fontWeight:700}}><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#9333ea" strokeWidth="2" strokeLinecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>Flujo</span>;
    return <span style={{display:'inline-flex',alignItems:'center',gap:3,background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:6,padding:'1px 6px',fontSize:9,color:'#16a34a',fontWeight:700}}><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>Agente</span>;
  };

  const StatusIcon = ({ status, isOut }) => {
    if (!isOut) return null;
    if (status === 'failed') return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>;
    if (status === 'read') return <span style={{display:'inline-flex'}}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" style={{marginLeft:-6}}><polyline points="20 6 9 17 4 12"/></svg></span>;
    if (status === 'delivered') return <span style={{display:'inline-flex'}}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" style={{marginLeft:-6}}><polyline points="20 6 9 17 4 12"/></svg></span>;
    return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
  };

  return (
    <>
      
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}
        body{overflow:hidden;}
        .si-root{display:flex;flex:1;overflow:hidden;height:100%;}
        .conv-layout{flex:1;display:flex;overflow:hidden;padding:8px 8px 8px 0;gap:0;}

        /* ── Left panel ── */
        .conv-list-panel{width:280px;background:#fff;border-right:1px solid #ebebeb;display:flex;flex-direction:column;flex-shrink:0;}
        .clp-header{padding:20px 16px 0;}
        .clp-top-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}
        .clp-title{font-size:22px;font-weight:700;color:#0a0a0a;letter-spacing:-0.4px;}
        .clp-top-actions{display:flex;align-items:center;gap:6px;}
        .clp-new-btn{display:flex;align-items:center;gap:5px;font-size:13px;font-weight:500;color:#0a0a0a;background:#f5f5f5;border:none;border-radius:999px;padding:6px 12px;cursor:pointer;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;transition:background 0.15s;}
        .clp-new-btn:hover{background:#ebebeb;}
        .clp-filter-btn{width:30px;height:30px;border-radius:50%;background:transparent;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.15s;}
        .clp-filter-btn:hover{background:#f0f0f0;}
        .clp-search{display:flex;align-items:center;gap:8px;background:#f5f5f5;border-radius:10px;padding:0 12px;height:36px;margin:0 0 14px;}
        .clp-search input{background:none;border:none;outline:none;font-size:13px;color:#0a0a0a;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;width:100%;}
        .clp-search input::placeholder{color:#c0c0c0;}
        .clp-toggle{display:flex;background:#f5f5f5;border-radius:10px;padding:3px;margin:0 0 16px;}
        .clp-toggle-btn{flex:1;text-align:center;padding:7px 0;border-radius:8px;font-size:13px;font-weight:500;cursor:pointer;border:none;background:transparent;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#888;transition:all 0.15s;}
        .clp-toggle-btn.active{background:#fff;color:#0a0a0a;font-weight:700;box-shadow:0 1px 3px rgba(0,0,0,0.09);}
        .clp-section-label{font-size:11px;font-weight:700;color:#b0b0b0;letter-spacing:0.04em;padding:10px 16px 6px;text-transform:none;}
        .clp-list{flex:1;overflow-y:auto;}
        .clp-list::-webkit-scrollbar{width:0;}
        .gs-item{padding:10px 16px;cursor:pointer;transition:background 0.1s;border-bottom:1px solid #f4f4f2;}
        .gs-item:hover{background:#f8f8f6;}
        .gs-name{font-size:13px;font-weight:700;color:#0a0a0a;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .gs-snippet{font-size:12px;color:#888;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .gs-time{font-size:10px;color:#c0c0c0;flex-shrink:0;margin-left:6px;}

        /* Conv items */
        .conv-item{display:flex;align-items:center;gap:12px;padding:11px 16px;cursor:pointer;transition:background 0.1s;position:relative;}
        .conv-item:hover{background:#f8f8f8;}
        .conv-item.active{background:#f0f0f0;}
        .ci-av-wrap{position:relative;flex-shrink:0;}
        .ci-av{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#555;}
        .ci-online{position:absolute;bottom:1px;left:1px;width:11px;height:11px;border-radius:50%;background:#22c55e;border:2px solid #fff;}
        .ci-body{flex:1;min-width:0;}
        .ci-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:2px;}
        .ci-name{font-size:14px;font-weight:700;color:#0a0a0a;letter-spacing:-0.1px;}
        .ci-time{font-size:11px;color:#b8b8b8;flex-shrink:0;}
        .ci-preview{font-size:12.5px;color:#9a9a9a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .ci-badge{min-width:19px;height:19px;border-radius:999px;background:#2196F3;color:#fff;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 5px;flex-shrink:0;margin-left:4px;}
        .ci-label-dot{width:7px;height:7px;border-radius:50%;flex-shrink:0;margin-left:4px;}
        .ctx-menu{position:fixed;background:#fff;border:1px solid #ebebeb;border-radius:12px;padding:5px;min-width:180px;box-shadow:0 8px 30px rgba(0,0,0,0.12);z-index:900;}
        .ctx-item{padding:9px 12px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:500;color:#0a0a0a;display:flex;align-items:center;gap:9px;transition:background 0.1s;}
        .ctx-item:hover{background:#f5f5f5;}
        .ctx-item.danger{color:#ef4444;}
        .ctx-item.danger:hover{background:#fef2f2;}
        .ctx-sep{height:1px;background:#f0f0f0;margin:4px 0;}
        .chat-panel{flex:1;display:flex;flex-direction:column;background:rgba(255,255,255,0.75);backdrop-filter:blur(12px) saturate(180%);-webkit-backdrop-filter:blur(12px) saturate(180%);border:1px solid rgba(255,255,255,0.3);border-radius:24px;box-shadow:0 8px 32px 0 rgba(31,38,135,0.07);overflow:hidden;}
        .chat-header{background:transparent;border-bottom:1px solid rgba(0,0,0,0.06);display:flex;align-items:center;justify-content:space-between;padding:16px 24px;gap:12px;flex-shrink:0;}
        .ch-av{width:46px;height:46px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#555;position:relative;flex-shrink:0;}
        .ch-channel{position:absolute;bottom:-1px;right:-1px;width:18px;height:18px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;border:1.5px solid #fff;}
        .ch-info{flex:1;min-width:0;}
        .ch-name-row{display:flex;align-items:center;gap:8px;margin-bottom:2px;}
        .ch-name{font-size:15px;font-weight:700;color:#111827;}
        .ch-note-badge{background:#E3F2FD;color:#1976D2;border-radius:9999px;padding:2px 10px;font-size:12px;font-weight:700;}
        .ch-sub{font-size:12px;color:#9CA3AF;}
        .ch-actions{display:flex;gap:16px;align-items:center;}
        .ch-btn-icon{width:34px;height:34px;border-radius:50%;border:none;background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background 0.15s;flex-shrink:0;color:#6B7280;}
        .ch-btn-icon:hover{background:rgba(0,0,0,0.05);}
        .messages-area{flex:1;overflow-y:auto;padding:20px;display:flex;flex-direction:column;gap:24px;}
        .date-sep{display:flex;align-items:center;gap:12px;margin:0;}
        .date-sep-line{flex:1;height:1px;background:#eee;}
        .date-sep-label{font-size:11px;font-weight:700;color:#bbb;letter-spacing:0.08em;white-space:nowrap;}
        .msg-row{display:flex;flex-direction:column;max-width:72%;}
        .msg-row.out{align-self:flex-end;align-items:flex-end;}
        .msg-row.in{align-self:flex-start;align-items:flex-start;}
        .msg-meta{display:flex;align-items:center;gap:6px;margin-bottom:5px;}
        .msg-av-sm{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;flex-shrink:0;}
        .msg-sender{font-size:12px;font-weight:700;color:#444;}
        .msg-ts{font-size:11px;color:#bbb;}
        .msg-bubble{padding:11px 15px;font-size:14px;line-height:1.6;word-break:break-word;}
        .msg-bubble.in{background:#F3F4F6;color:#111827;border-radius:2px 18px 18px 18px;}
        .msg-bubble.out{background:#E8F0FE;color:#111827;border-radius:18px 2px 18px 18px;}
        .quoted-msg{display:flex;gap:8px;margin-bottom:8px;padding:7px 10px;border-radius:8px;background:rgba(0,0,0,0.06);cursor:default;overflow:hidden;}
        .quoted-bar{width:3px;border-radius:2px;flex-shrink:0;background:#3b82f6;}
        .quoted-body{flex:1;min-width:0;}
        .quoted-sender{font-size:11px;font-weight:700;color:#3b82f6;margin-bottom:2px;}
        .quoted-text{font-size:12px;color:#555;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .msg-status-row{display:flex;align-items:center;gap:4px;margin-top:4px;}
        .msg-actions{display:none;gap:4px;margin-top:3px;}
        .msg-row:hover .msg-actions{display:flex;}
        .msg-action-btn{padding:3px 9px;border-radius:6px;border:1px solid #e4e4e2;background:#fff;cursor:pointer;font-size:11px;color:#555;display:flex;align-items:center;gap:4px;transition:background 0.12s;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}
        .msg-action-btn:hover{background:#f0f0ee;border-color:#d0d0ce;}
        .reply-preview{display:flex;align-items:center;gap:10px;padding:9px 18px;background:#f8f8f6;border-top:1px solid #eeeeec;border-bottom:none;}
        .reply-bar{width:3px;height:36px;background:#3b82f6;border-radius:2px;flex-shrink:0;}
        .reply-preview-body{flex:1;min-width:0;}
        .reply-preview-sender{font-size:11px;font-weight:700;color:#3b82f6;margin-bottom:2px;}
        .reply-preview-text{font-size:12px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .reply-close{background:none;border:none;cursor:pointer;padding:4px;color:#aaa;font-size:18px;line-height:1;flex-shrink:0;}
        .reply-close:hover{color:#555;}
        .chat-input-wrapper{background:transparent;border-top:1px solid rgba(0,0,0,0.05);flex-shrink:0;position:relative;padding:12px 16px 16px;}
        .chat-input-pill{position:relative;border:1px solid #E5E7EB;border-radius:24px;background:#fff;padding:12px 52px 12px 16px;transition:border-color 0.2s;box-shadow:0 1px 4px rgba(0,0,0,0.04);}
        .chat-input-pill:focus-within{border-color:#9CA3AF;box-shadow:0 1px 4px rgba(0,0,0,0.08);}
        .ci-input{display:block;width:100%;background:transparent;border:none;outline:none;font-size:14px;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#111827;resize:none;height:auto;max-height:120px;overflow-y:auto;line-height:1.5;padding:0;}
        .ci-input::placeholder{color:#9CA3AF;}
        .ci-send{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;background:#0a0a0a;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;transition:background 0.15s;}
        .ci-send:hover{background:#333;} .ci-send:disabled{background:#ccc;cursor:not-allowed;}
        .chat-toolbar{background:#F9FAFB;border-radius:16px;padding:8px 12px;margin-top:8px;display:flex;align-items:center;gap:2px;border:none;}
        .toolbar-btn{display:flex;align-items:center;gap:5px;padding:6px 12px;border-radius:8px;border:none;background:transparent;cursor:pointer;font-size:12px;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;font-weight:500;color:#666;transition:background 0.15s;}
        .toolbar-btn:hover{background:#eeeeec;}
        .shopify-btn{color:#16a34a;}
        .shopify-btn:hover{background:#f0fdf4;}
        .ci-attach{display:none;}
        .ci-mic{display:none;}
        @keyframes pulse-red{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,0.3)}50%{box-shadow:0 0 0 6px rgba(239,68,68,0)}}
        .info-panel{width:300px;background:#fff;border-left:1px solid #e8e8e6;display:flex;flex-direction:column;flex-shrink:0;overflow:hidden;}
        .ip-tabs{display:flex;border-bottom:1px solid #e8e8e6;flex-shrink:0;}
        .ip-tab{flex:1;padding:16px 8px;font-size:13px;font-weight:500;color:#aaa;text-align:center;cursor:pointer;border-bottom:2px solid transparent;transition:all 0.15s;}
        .ip-tab.active{color:#0a0a0a;border-bottom-color:#0a0a0a;}
        .ip-body{flex:1;overflow-y:auto;padding:16px;}
        .ip-section-title{font-size:10px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px;}
        .ip-row{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;}
        .ip-label{font-size:12px;color:#aaa;}
        .ip-value{font-size:12px;font-weight:500;color:#0a0a0a;text-align:right;max-width:55%;}
        .order-card{background:#f8f8f6;border-radius:12px;padding:12px;margin-bottom:10px;border:1px solid #f0f0ee;}
        .order-card-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;}
        .order-num{font-size:13px;font-weight:700;color:#0a0a0a;}
        .order-status{font-size:10px;font-weight:700;padding:2px 8px;border-radius:999px;}
        .status-entregado{background:#f0fdf4;color:#16a34a;}
        .status-pendiente{background:#fef9c3;color:#854d0e;}
        .order-product{font-size:12px;color:#555;margin-bottom:2px;}
        .order-price{font-size:13px;font-weight:700;color:#0a0a0a;margin-top:4px;}
        .order-meta{display:flex;justify-content:space-between;align-items:center;margin-top:6px;padding-top:6px;border-top:1px solid #f0f0ee;}
        .order-guia{font-size:11px;color:#3b82f6;font-weight:500;}
        .novedad-item{display:flex;gap:10px;margin-bottom:10px;position:relative;}
        .novedad-item:not(:last-child)::after{content:'';position:absolute;left:5px;top:14px;bottom:-4px;width:1px;background:#e8e8e6;}
        .novedad-dot{width:11px;height:11px;border-radius:50%;flex-shrink:0;margin-top:3px;}
        .novedad-title{font-size:12px;font-weight:700;margin-bottom:1px;}
        .novedad-desc{font-size:11px;color:#888;}
        .novedad-time{font-size:10px;color:#bbb;margin-top:1px;}
        .hist-item{display:flex;justify-content:space-between;align-items:center;padding:8px 10px;background:#f8f8f6;border-radius:8px;margin-bottom:6px;}
        .note-input-wrap{display:flex;flex-direction:column;gap:7px;}
        .note-input{background:#f6f6f4;border:1px solid #e8e8e6;border-radius:10px;padding:11px 13px;font-size:13px;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;outline:none;color:#0a0a0a;resize:none;width:100%;height:72px;}
        .note-input::placeholder{color:#bbb;}
        .note-btn{background:#0a0a0a;color:#fff;border:none;border-radius:9px;padding:8px 16px;font-size:12px;font-weight:700;cursor:pointer;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;align-self:flex-end;}
        .empty-state{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:12px;color:#aaa;}
        @keyframes spin{to{transform:rotate(360deg)}}
        .spinner{width:18px;height:18px;border:2px solid #e8e8e6;border-top-color:#0a0a0a;border-radius:50%;animation:spin 0.7s linear infinite;}
        .live-dot{width:7px;height:7px;border-radius:50%;background:#22c55e;animation:pulse 2s infinite;}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
        .seg-badge{display:inline-block;padding:2px 8px;border-radius:999px;font-size:11px;font-weight:700;}
        .seg-vip{background:#fef9c3;color:#854d0e;} .seg-recurrente{background:#eff6ff;color:#1d4ed8;}
        .seg-nuevo{background:#f0fdf4;color:#166534;} .seg-inactivo{background:#f4f4f2;color:#888;}
        .modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.4);z-index:500;display:flex;align-items:center;justify-content:center;}
        .modal{background:#fff;border-radius:20px;padding:24px;box-shadow:0 20px 60px rgba(0,0,0,0.2);max-height:90vh;display:flex;flex-direction:column;}
        .modal-hdr{display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;flex-shrink:0;}
        .modal-title{font-size:17px;font-weight:700;color:#0a0a0a;}
        .modal-close{width:30px;height:30px;border-radius:8px;border:1px solid #e8e8e6;background:#f6f6f4;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#888;}
        .modal-search{display:flex;align-items:center;gap:8px;background:#f6f6f4;border:1px solid #e8e8e6;border-radius:10px;padding:0 12px;height:38px;margin-bottom:14px;flex-shrink:0;}
        .modal-search input{background:none;border:none;outline:none;font-size:13px;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#0a0a0a;width:100%;}
        .modal-scroll{flex:1;overflow-y:auto;}
        .tpl-item{padding:12px 14px;border-radius:12px;border:1px solid #e8e8e6;margin-bottom:8px;cursor:pointer;transition:all 0.15s;}
        .tpl-item:hover{border-color:#0a0a0a;background:#f8f8f6;}
        .tpl-name{font-size:13px;font-weight:700;color:#0a0a0a;margin-bottom:4px;}
        .tpl-text{font-size:12px;color:#888;line-height:1.5;}
        .tpl-badge{display:inline-block;font-size:10px;padding:2px 7px;border-radius:999px;font-weight:700;margin-bottom:6px;}
        .flow-item{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;border:1px solid #e8e8e6;margin-bottom:8px;cursor:pointer;transition:all 0.15s;}
        .flow-item:hover{border-color:#0a0a0a;background:#f8f8f6;}
        .options-menu{background:#fff;border:1px solid #e8e8e6;border-radius:12px;padding:6px;width:210px;box-shadow:0 4px 20px rgba(0,0,0,0.12);}
        .options-item{display:flex;align-items:center;gap:9px;padding:9px 12px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:500;transition:background 0.12s;}
        .options-item:hover{background:#f4f4f2;} .options-item.danger{color:#ef4444;} .options-item.danger:hover{background:#fef2f2;}
        .action-btn{width:100%;padding:10px;border-radius:10px;border:1px solid #e8e8e6;background:#fff;font-size:13px;font-weight:500;cursor:pointer;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#0a0a0a;margin-bottom:8px;display:flex;align-items:center;gap:8px;transition:background 0.15s;}
        .action-btn:hover{background:#f4f4f2;} .action-btn.danger{color:#ef4444;border-color:#fee2e2;} .action-btn.danger:hover{background:#fef2f2;} .action-btn.disabled{opacity:0.4;cursor:not-allowed;}
        .call-option{display:flex;align-items:center;gap:12px;padding:14px;border-radius:12px;border:1px solid #e8e8e6;margin-bottom:8px;cursor:pointer;transition:all 0.15s;}
        .call-option:hover{border-color:#0a0a0a;background:#f8f8f6;}
      `}</style>

      <input ref={fileInputRef} type="file" style={{display:'none'}}
        accept="image/*,video/mp4,video/3gpp,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip"
        onChange={e => {
          const file = e.target.files[0];
          if (file) {
            const type = file.type.startsWith('image/') ? 'image' : file.type.startsWith('video/') ? 'video' : file.type.startsWith('audio/') ? 'audio' : 'document';
            const previewUrl = (type === 'image' || type === 'video') ? URL.createObjectURL(file) : null;
            setPendingMedia({ file, previewUrl, type });
          }
          e.target.value='';
        }}
      />

      <div className="si-root">
          {/* Context menu global */}
          {contextMenu && (
            <div className="ctx-menu" style={{top:contextMenu.y, left:contextMenu.x}} onClick={e=>e.stopPropagation()}>
              <div className="ctx-item" onClick={()=>{ toggleFav(contextMenu.convId); setContextMenu(null); }}>
                {favConvs.has(contextMenu.convId) ? (
                  <><svg width="14" height="14" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>Quitar de favoritos</>
                ) : (
                  <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>Agregar a favoritos</>
                )}
              </div>
              <div className="ctx-sep"/>
              <div style={{padding:'4px 12px 6px',fontSize:11,fontWeight:700,color:'#b0b0b0',textTransform:'uppercase',letterSpacing:'0.04em'}}>Etiqueta</div>
              {[['pedido','#3b82f6','Pedido'],['novedad','#f59e0b','Novedad'],['garantia','#16a34a','Garantía']].map(([id,color,label])=>(
                <div key={id} className="ctx-item" onClick={()=>setLabel(contextMenu.convId, convLabels[contextMenu.convId]===id ? null : id)}>
                  <div style={{width:8,height:8,borderRadius:'50%',background:color,flexShrink:0}}/>
                  {label}
                  {convLabels[contextMenu.convId]===id && <svg style={{marginLeft:'auto'}} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                </div>
              ))}
              <div className="ctx-sep"/>
              <div className="ctx-item danger" onClick={()=>setContextMenu(null)}>Cancelar</div>
            </div>
          )}

          <div className="conv-layout" onClick={()=>{ if(contextMenu) setContextMenu(null); if(showLabelFilter) setShowLabelFilter(false); }}>
            <div className="conv-list-panel">

              {/* ── Header ── */}
              <div className="clp-header">
                <div className="clp-top-row">
                  <div className="clp-title">Social</div>
                  <div className="clp-top-actions">
                    <div style={{position:'relative'}}>
                      <button className="clp-filter-btn" onClick={e=>{e.stopPropagation();setShowLabelFilter(v=>!v);}}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="5" r="1" fill="#555"/><circle cx="12" cy="12" r="1" fill="#555"/><circle cx="12" cy="19" r="1" fill="#555"/></svg>
                      </button>
                      {showLabelFilter && (
                        <div className="ctx-menu" style={{position:'absolute',top:'110%',right:0}} onClick={e=>e.stopPropagation()}>
                          <div style={{padding:'6px 12px 8px',fontSize:11,fontWeight:700,color:'#b0b0b0',textTransform:'uppercase',letterSpacing:'0.04em'}}>Filtrar por etiqueta</div>
                          <div className="ctx-item" onClick={()=>{setLabelFilter(null);setShowLabelFilter(false);}}>
                            Todos {!labelFilter && <svg style={{marginLeft:'auto'}} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                          </div>
                          {[['pedido','#3b82f6','Pedido'],['novedad','#f59e0b','Novedad'],['garantia','#16a34a','Garantía']].map(([id,color,label])=>(
                            <div key={id} className="ctx-item" onClick={()=>{setLabelFilter(id);setShowLabelFilter(false);}}>
                              <div style={{width:8,height:8,borderRadius:'50%',background:color}}/>
                              {label}
                              {labelFilter===id && <svg style={{marginLeft:'auto'}} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Search */}
                <div className="clp-search">
                  <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#c0c0c0" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#c0c0c0" strokeWidth="1.5" strokeLinecap="round"/></svg>
                  <input placeholder="Buscar contacto..." value={searchQuery} onChange={e=>setSearchQuery(e.target.value)}/>
                </div>

                {/* Toggle Nuevos / Resueltos */}
                <div className="clp-toggle">
                  <button className={`clp-toggle-btn${listTab==='nuevos'?' active':''}`} onClick={()=>setListTab('nuevos')}>Nuevos</button>
                  <button className={`clp-toggle-btn${listTab==='resueltos'?' active':''}`} onClick={()=>setListTab('resueltos')}>Resueltos</button>
                </div>
              </div>

              {/* ── List ── */}
              <div className="clp-list">
                {loading ? (
                  <div style={{display:'flex',justifyContent:'center',padding:40}}><div className="spinner"/></div>
                ) : searchQuery.length >= 3 && (globalSearchLoading || globalResults.length > 0) ? (
                  <>
                    <div className="clp-section-label" style={{display:'flex',alignItems:'center',gap:6}}>
                      {globalSearchLoading
                        ? <><div className="spinner" style={{width:10,height:10,borderWidth:1.5}}/>Buscando...</>
                        : `${globalResults.length} mensaje${globalResults.length!==1?'s':''} encontrado${globalResults.length!==1?'s':''}`
                      }
                    </div>
                    {globalResults.map(r => {
                      const q = searchQuery.toLowerCase();
                      const content = r.content || '';
                      const idx = content.toLowerCase().indexOf(q);
                      const snippet = idx >= 0
                        ? content.slice(Math.max(0, idx - 20), idx + 60)
                        : content.slice(0, 80);
                      return (
                        <div key={`${r.conv_id}_${r.message_id}`} className="gs-item" onClick={()=>{ setActiveConv(r.conv_id); markRead(r.conv_id); setSearchQuery(''); }}>
                          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <div className="gs-name">{r.conv_name || r.conv_phone}</div>
                            <div className="gs-time">{fmtTime(r.sent_at)}</div>
                          </div>
                          <div className="gs-snippet">
                            {idx >= 0 ? (
                              <>
                                {idx > 20 ? '…' : ''}{content.slice(Math.max(0,idx-20), idx)}
                                <mark style={{background:'#fef08a',borderRadius:2,padding:'0 1px',color:'#0a0a0a'}}>{content.slice(idx, idx+q.length)}</mark>
                                {content.slice(idx+q.length, idx+60)}{content.length > idx+60 ? '…' : ''}
                              </>
                            ) : snippet}
                          </div>
                        </div>
                      );
                    })}
                    {!globalSearchLoading && globalResults.length === 0 && (
                      <div style={{padding:'24px 20px',textAlign:'center',color:'#c0c0c0',fontSize:13}}>Sin resultados para "{searchQuery}"</div>
                    )}
                  </>
                ) : (() => {
                  // Filter by tab
                  const byTab = conversations.filter(c => {
                    const st = convStatuses[c.id] || c.status || 'open';
                    if (listTab === 'resueltos') return st === 'resolved';
                    return st !== 'resolved';
                  });
                  // Filter by search
                  const bySearch = byTab.filter(c => {
                    if (!searchQuery) return true;
                    const q = searchQuery.toLowerCase();
                    return (c.contact_name||'').toLowerCase().includes(q) || (c.contact_phone||'').includes(q);
                  });
                  // Filter by label
                  const byLabel = labelFilter ? bySearch.filter(c => convLabels[c.id] === labelFilter) : bySearch;
                  // Split favorites / rest
                  const favs = byLabel.filter(c => favConvs.has(c.id));
                  const rest = byLabel.filter(c => !favConvs.has(c.id));

                  const renderItem = (c, idx) => {
                    const labelColors = {pedido:'#3b82f6',novedad:'#f59e0b',garantia:'#16a34a'};
                    const lbl = convLabels[c.id];
                    const hasUnread = (c.unread_count||0) > 0 && activeConv !== c.id;
                    return (
                      <div key={c.id}
                        className={`conv-item${activeConv===c.id?' active':''}`}
                        onClick={()=>{setActiveConv(c.id);markRead(c.id);setContextMenu(null);}}
                        onContextMenu={e=>{e.preventDefault();setContextMenu({x:e.clientX,y:e.clientY,convId:c.id});}}
                      >
                        <div className="ci-av-wrap">
                          <div className="ci-av" style={{background:AVATAR_COLORS[idx%AVATAR_COLORS.length]}}>
                            {initials(c.contact_name)}
                          </div>
                          <div className="ci-online"/>
                        </div>
                        <div className="ci-body">
                          <div className="ci-top">
                            <span className="ci-name" style={hasUnread?{fontWeight:700}:{}}>{c.contact_name||c.contact_phone}</span>
                            <span className="ci-time">{fmtTime(c.last_message_at)}</span>
                          </div>
                          <div className="ci-preview" style={hasUnread?{color:'#555',fontWeight:500}:{}}>{c.last_message||'Sin mensajes'}</div>
                        </div>
                        {hasUnread && <div className="ci-badge">{c.unread_count}</div>}
                        {lbl && <div className="ci-label-dot" style={{background:labelColors[lbl]}}/>}
                        {favConvs.has(c.id) && !hasUnread && <svg width="10" height="10" viewBox="0 0 24 24" fill="#f59e0b" stroke="none" style={{flexShrink:0,marginLeft:2}}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>}
                      </div>
                    );
                  };

                  if (byLabel.length === 0) return <div style={{padding:'40px 20px',textAlign:'center',color:'#c0c0c0',fontSize:13}}>Sin conversaciones</div>;

                  return (
                    <>
                      {favs.length > 0 && (
                        <>
                          <div className="clp-section-label">Favoritos</div>
                          {favs.map((c,i)=>renderItem(c,i))}
                        </>
                      )}
                      {rest.length > 0 && (
                        <>
                          <div className="clp-section-label">{favs.length > 0 ? 'Mensajes' : 'Todos los chats'}</div>
                          {rest.map((c,i)=>renderItem(c,favs.length+i))}
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>

            <div className="chat-panel">
              {!conv ? (
                <div className="empty-state">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.5" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                  <div style={{fontSize:14,fontWeight:500}}>Selecciona una conversación</div>
                  <div style={{fontSize:12}}>Los mensajes aparecen aquí en tiempo real</div>
                </div>
              ) : (
                <>
                  <div className="chat-header">
                    <div className="ch-av" style={{background:AVATAR_COLORS[filtered.findIndex(c=>c.id===activeConv)%AVATAR_COLORS.length]}}>
                      {initials(conv.contact_name)}
                      <div className="ch-channel"><ChannelIcon ch={conv.channel||'instagram'}/></div>
                    </div>
                    <div className="ch-info">
                      <div className="ch-name-row">
                        <div className="ch-name">{conv.contact_name || conv.contact_phone}</div>
                        {notes.length > 0 && <span className="ch-note-badge">{notes.length} {notes.length===1?'Note':'Notes'}</span>}
                        {assignedAgent[activeConv] && <span style={{fontSize:11,color:'#3b82f6',fontWeight:700,background:'#eff6ff',padding:'2px 8px',borderRadius:999}}>{assignedAgent[activeConv]}</span>}
                      </div>
                      <div className="ch-sub">{conv.contact_phone}</div>
                    </div>
                    <div className="ch-actions">
                      {/* Status pill */}
                      <div style={{position:'relative'}}>
                        <button onClick={()=>{setShowStatusMenu(!showStatusMenu);setShowOptionsMenu(false);setShowCallMenu(false);}} style={{display:'flex',alignItems:'center',gap:5,fontSize:12,padding:'5px 12px',borderRadius:999,fontWeight:700,border:'none',cursor:'pointer',fontFamily:'inherit',background:statusObj.bg,color:statusObj.color}}>
                          {statusObj.label}
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={statusObj.color} strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
                        </button>
                        {showStatusMenu && (
                          <div style={{position:'absolute',top:'110%',right:0,background:'#fff',border:'1px solid #e8e8e6',borderRadius:12,padding:'6px',width:160,boxShadow:'0 4px 20px rgba(0,0,0,0.1)',zIndex:200}}>
                            {STATUS_OPTIONS.map(s=>(
                              <div key={s.id} onClick={()=>{setConvStatuses(p=>({...p,[activeConv]:s.id}));setShowStatusMenu(false);}} style={{display:'flex',alignItems:'center',gap:8,padding:'8px 10px',borderRadius:8,cursor:'pointer'}} onMouseEnter={e=>e.currentTarget.style.background=s.bg} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                                <div style={{width:8,height:8,borderRadius:'50%',background:s.color}}/>
                                <span style={{fontSize:13,fontWeight:500,color:s.color}}>{s.label}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {/* Call */}
                      <div style={{position:'relative'}}>
                        <div className="ch-btn-icon" onClick={()=>{setShowCallMenu(!showCallMenu);setShowStatusMenu(false);setShowOptionsMenu(false);}}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.8" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16z"/></svg>
                        </div>
                        {showCallMenu && (
                          <div style={{position:'absolute',top:'110%',right:0,background:'#fff',border:'1px solid #e8e8e6',borderRadius:14,padding:8,width:240,boxShadow:'0 4px 24px rgba(0,0,0,0.12)',zIndex:300}}>
                            <div className="call-option" onClick={()=>{setShowCallMenu(false);setShowCallIA(true);}}>
                              <div style={{width:36,height:36,borderRadius:10,background:'linear-gradient(135deg,#6ee7b7,#3b82f6)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M12 11V7"/><circle cx="12" cy="5" r="2"/></svg></div>
                              <div><div style={{fontSize:13,fontWeight:700,color:'#0a0a0a'}}>Llamar con IA</div><div style={{fontSize:11,color:'#aaa'}}>Zadarma + IA, elige el tipo</div></div>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Search in chat */}
                      <div className="ch-btn-icon" title="Buscar en chat (Ctrl+F)" onClick={()=>{ setShowChatSearch(v=>!v); setChatSearchTerm(''); setTimeout(()=>chatSearchRef.current?.focus(),50); }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={showChatSearch?'#0a0a0a':'#888'} strokeWidth="1.8" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>
                      </div>
                      {/* Three dots */}
                      <div style={{position:'relative'}} ref={optionsRef}>
                        <div className="ch-btn-icon" onClick={()=>{setShowOptionsMenu(!showOptionsMenu);setShowStatusMenu(false);setShowCallMenu(false);}}>
                          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="5" r="1" fill="#888"/><circle cx="12" cy="12" r="1" fill="#888"/><circle cx="12" cy="19" r="1" fill="#888"/></svg>
                        </div>
                        {showOptionsMenu && (
                          <div className="options-menu" style={{position:'absolute',top:'110%',right:0,zIndex:300}}>
                            {OPTIONS_MENU.map((opt) => (
                              <div key={opt.id} className={`options-item${opt.danger?' danger':''}`} onClick={()=>{
                                setShowOptionsMenu(false);
                                if (opt.id === 'assign') setShowAssign(true);
                                if (opt.id === 'history') setActiveTab('notas');
                                if (opt.id === 'archive') setConvStatuses(p=>({...p,[activeConv]:'resolved'}));
                                if (opt.id === 'spam') alert('Conversación marcada como spam');
                              }}>{opt.icon}<span>{opt.label}</span></div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* ── In-chat search bar ── */}
                  {showChatSearch && (
                    <div style={{background:'#fff',borderBottom:'1px solid #eeeeec',padding:'10px 20px',display:'flex',alignItems:'center',gap:10,flexShrink:0}}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="1.8" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>
                      <input
                        ref={chatSearchRef}
                        value={chatSearchTerm}
                        onChange={e=>setChatSearchTerm(e.target.value)}
                        onKeyDown={e=>{ if(e.key==='Enter'){ e.shiftKey ? goSearchPrev() : goSearchNext(); } if(e.key==='Escape'){setShowChatSearch(false);setChatSearchTerm('');} }}
                        placeholder="Buscar en esta conversación..."
                        style={{flex:1,border:'none',outline:'none',fontSize:13,fontFamily:'inherit',color:'#0a0a0a',background:'transparent'}}
                      />
                      {chatSearchTerm.length >= 2 && (
                        <span style={{fontSize:11,color:'#aaa',whiteSpace:'nowrap',flexShrink:0}}>
                          {searchMatches.length === 0 ? 'Sin resultados' : `${chatSearchIdx+1} / ${searchMatches.length}`}
                        </span>
                      )}
                      {searchMatches.length > 1 && (
                        <>
                          <button onClick={goSearchPrev} style={{width:26,height:26,borderRadius:6,border:'1px solid #e4e4e2',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round"><polyline points="18 15 12 9 6 15"/></svg>
                          </button>
                          <button onClick={goSearchNext} style={{width:26,height:26,borderRadius:6,border:'1px solid #e4e4e2',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
                          </button>
                        </>
                      )}
                      <button onClick={()=>{setShowChatSearch(false);setChatSearchTerm('');}} style={{width:26,height:26,borderRadius:6,border:'none',background:'transparent',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:'#aaa',fontSize:16,flexShrink:0}}>×</button>
                    </div>
                  )}

                  <div className="messages-area" ref={messagesAreaRef}>
                    {/* Botón cargar anteriores */}
                    {hasMoreMsgs && !loadingMsgs && (
                      <div style={{display:'flex',justifyContent:'center',marginBottom:8,flexShrink:0}}>
                        <button onClick={loadMoreMessages} disabled={loadingMore} style={{display:'flex',alignItems:'center',gap:6,padding:'6px 16px',borderRadius:999,border:'1px solid #e4e4e2',background:'#fff',fontSize:12,fontWeight:500,color:'#555',cursor:loadingMore?'not-allowed':'pointer',fontFamily:'inherit',transition:'background 0.15s'}}>
                          {loadingMore ? <><div className="spinner" style={{width:11,height:11}}/> Cargando...</> : <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><polyline points="18 15 12 9 6 15"/></svg> Cargar mensajes anteriores</>}
                        </button>
                      </div>
                    )}
                    {loadingMsgs ? (
                      <div style={{display:'flex',justifyContent:'center',padding:32}}><div className="spinner"/></div>
                    ) : messages.length === 0 ? (
                      <div style={{textAlign:'center',color:'#bbb',fontSize:13,marginTop:32}}>No hay mensajes aún</div>
                    ) : (() => {
                      let lastDateStr = null;
                      const convIdx = filtered.findIndex(c=>c.id===activeConv);
                      const avatarBg = AVATAR_COLORS[convIdx % AVATAR_COLORS.length];
                      return messages.map((m) => {
                        const isOut = m.role === 'outbound' || m.direction === 'outbound';
                        const source = m.source || 'agent';
                        const status = m.status || 'sent';
                        const rawMediaUrl = m.media_url || (m.content && m.content.startsWith('https://') ? m.content : null);
                        const isLocalMedia = rawMediaUrl && rawMediaUrl.includes('/whatsapp/media/');
                        const proxyUrl = rawMediaUrl ? (isLocalMedia ? rawMediaUrl : `${API}/whatsapp/media-proxy?url=${encodeURIComponent(rawMediaUrl)}`) : null;
                        const mediaType = m.media_type || null;
                        const hasError = mediaErrors[m.id];

                        // Date separator
                        const msgDate = m.sent_at || m.created_at;
                        let dateLabel = null;
                        if (msgDate) {
                          try {
                            const d = new Date(String(msgDate).replace(' ','T') + (String(msgDate).includes('+') || String(msgDate).includes('Z') ? '' : '-05:00'));
                            const today = new Date(); today.setHours(0,0,0,0);
                            const yesterday = new Date(today); yesterday.setDate(today.getDate()-1);
                            d.setHours(0,0,0,0);
                            const ds = d.toDateString();
                            if (ds !== lastDateStr) {
                              lastDateStr = ds;
                              if (d.getTime() === today.getTime()) dateLabel = 'HOY';
                              else if (d.getTime() === yesterday.getTime()) dateLabel = 'AYER';
                              else dateLabel = d.toLocaleDateString('es-CO',{day:'numeric',month:'long'}).toUpperCase();
                            }
                          } catch(e) {}
                        }

                        const senderName = isOut ? (user?.name?.split(' ')[0] || 'Tú') : (conv.contact_name || conv.contact_phone);

                        return (
                          <React.Fragment key={m.id}>
                            {dateLabel && (
                              <div className="date-sep">
                                <div className="date-sep-line"/>
                                <span className="date-sep-label">{dateLabel}</span>
                                <div className="date-sep-line"/>
                              </div>
                            )}
                            <div ref={el=>msgRefs.current[m.id]=el} className={`msg-row ${isOut?'out':'in'}`}>
                              {/* Meta row above bubble */}
                              <div className="msg-meta" style={{flexDirection: isOut ? 'row-reverse' : 'row'}}>
                                <div className="msg-av-sm" style={{background: isOut ? '#0a0a0a' : avatarBg, color: isOut ? '#fff' : '#555'}}>
                                  {isOut ? (user?.name?.[0]||'T') : initials(conv.contact_name)}
                                </div>
                                <span className="msg-sender">{senderName}</span>
                                <span className="msg-ts">{fmtTime(m.sent_at || m.created_at)}</span>
                                {isOut && <SourceBadge source={source} isOut={isOut}/>}
                              </div>
                              {/* Bubble */}
                              <div className={`msg-bubble ${isOut?'out':'in'}`}>
                                {m.quoted_content && (
                                  <div className="quoted-msg">
                                    <div className="quoted-bar"/>
                                    <div className="quoted-body">
                                      <div className="quoted-sender">{m.quoted_sender || 'Mensaje'}</div>
                                      <div className="quoted-text">{m.quoted_content.slice(0, 100)}</div>
                                    </div>
                                  </div>
                                )}
                                {proxyUrl && !hasError ? (
                                  mediaType === 'audio' ?
                                    <audio controls src={proxyUrl} style={{maxWidth:'100%',borderRadius:8}} onError={()=>setMediaErrors(p=>({...p,[m.id]:true}))} /> :
                                  mediaType === 'video' ?
                                    <video controls src={proxyUrl} style={{maxWidth:'100%',borderRadius:8,maxHeight:200,cursor:'pointer'}} onClick={()=>setImgModal({url:proxyUrl,type:'video'})} onError={()=>setMediaErrors(p=>({...p,[m.id]:true}))} /> :
                                  mediaType === 'document' ?
                                    <a href={proxyUrl} target="_blank" rel="noreferrer" style={{color:'#3b82f6',fontSize:13,display:'flex',alignItems:'center',gap:6}}>📄 Ver documento</a> :
                                  mediaType === 'sticker' ?
                                    <div style={{position:'relative',display:'inline-block'}}>
                                      <img src={proxyUrl} alt="sticker" style={{maxWidth:120,borderRadius:8,cursor:'pointer'}} onClick={()=>setImgModal(proxyUrl)} onError={()=>setMediaErrors(p=>({...p,[m.id]:true}))} />
                                      <span style={{position:'absolute',top:4,right:4,background:'rgba(0,0,0,0.5)',color:'#fff',fontSize:9,fontWeight:700,padding:'1px 5px',borderRadius:6}}>Sticker</span>
                                    </div> :
                                    <img src={proxyUrl} alt="imagen" style={{maxWidth:'100%',borderRadius:8,maxHeight:300,cursor:'pointer'}} onClick={()=>setImgModal(proxyUrl)} onError={()=>setMediaErrors(p=>({...p,[m.id]:true}))} />
                                ) : hasError ? <MediaExpired type={mediaType} /> :
                                  m.content === '[Sticker]' ? '🎭 Sticker' :
                                  m.content === '' || !m.content ? '📎 Archivo' :
                                  chatSearchTerm.length >= 2 ? highlightText(m.content, chatSearchTerm) : m.content}
                              </div>
                              {/* Hover actions */}
                              {m.content && m.content !== '[Sticker]' && (
                                <div className="msg-actions">
                                  <button className="msg-action-btn" onClick={()=>setReplyTo({id:m.id,content:m.content,sender:senderName,wamid:m.twilio_sid||null})}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>
                                    Responder
                                  </button>
                                </div>
                              )}
                              {/* Status under bubble for outbound */}
                              {isOut && (
                                <div className="msg-status-row">
                                  <StatusIcon status={status} isOut={isOut}/>
                                  {status === 'failed' && <span style={{fontSize:10,color:'#ef4444'}}>No entregado</span>}
                                </div>
                              )}
                            </div>
                          </React.Fragment>
                        );
                      });
                    })()}
                  </div>

                  {/* Pending media preview */}
                  {pendingMedia && (
                    <div style={{padding:'10px 18px',borderTop:'1px solid #f0f0ee',background:'#fff',display:'flex',alignItems:'center',gap:12}}>
                      {pendingMedia.type==='image' && pendingMedia.previewUrl && <img src={pendingMedia.previewUrl} alt="preview" style={{height:56,width:56,objectFit:'cover',borderRadius:8,flexShrink:0}}/>}
                      {pendingMedia.type==='video' && pendingMedia.previewUrl && <video src={pendingMedia.previewUrl} style={{height:56,width:80,objectFit:'cover',borderRadius:8,flexShrink:0}} muted/>}
                      {pendingMedia.type==='audio' && <div style={{width:36,height:36,borderRadius:8,background:'#f0fdf4',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg></div>}
                      {pendingMedia.type==='document' && <div style={{width:36,height:36,borderRadius:8,background:'#eff6ff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>}
                      <div style={{flex:1,minWidth:0}}><div style={{fontSize:12,fontWeight:700,color:'#0a0a0a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{pendingMedia.file.name}</div><div style={{fontSize:11,color:'#aaa'}}>{(pendingMedia.file.size/1024).toFixed(0)} KB</div></div>
                      <button onClick={()=>{ if(pendingMedia.previewUrl) URL.revokeObjectURL(pendingMedia.previewUrl); setPendingMedia(null); }} style={{padding:'5px 11px',borderRadius:8,border:'1px solid #e8e8e6',background:'#fff',fontSize:12,cursor:'pointer',fontFamily:'inherit',color:'#555'}}>Cancelar</button>
                      <button disabled={sending} onClick={async()=>{ const mm=pendingMedia; setPendingMedia(null); if(mm.previewUrl) URL.revokeObjectURL(mm.previewUrl); await sendMedia(mm.file); }} style={{padding:'5px 13px',borderRadius:8,border:'none',background:'#0a0a0a',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:5}}>
                        {sending?<div className="spinner" style={{width:11,height:11,borderTopColor:'#fff'}}/>:<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>}
                        Enviar
                      </button>
                    </div>
                  )}
                  {sendError && (
                    <div style={{padding:'5px 18px',background:'#fef2f2',display:'flex',alignItems:'center',gap:8}}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="0.5" fill="#ef4444"/></svg>
                      <span style={{fontSize:11,color:'#ef4444',flex:1}}>{sendError}</span>
                      <button onClick={()=>setSendError('')} style={{fontSize:11,color:'#aaa',background:'none',border:'none',cursor:'pointer',padding:0}}>✕</button>
                    </div>
                  )}

                  {/* Quote preview when replying */}
                  {replyTo && (
                    <div className="reply-preview">
                      <div className="reply-bar"/>
                      <div className="reply-preview-body">
                        <div className="reply-preview-sender">{replyTo.sender}</div>
                        <div className="reply-preview-text">{replyTo.content.slice(0, 90)}</div>
                      </div>
                      <button className="reply-close" onClick={()=>setReplyTo(null)}>×</button>
                    </div>
                  )}

                  {/* ── New input area ── */}
                  <div className="chat-input-wrapper">
                    {recording ? (
                      <div style={{margin:'12px 18px 0',display:'flex',alignItems:'center',gap:10,background:'#fef2f2',border:'1.5px solid #fecaca',borderRadius:999,padding:'0 10px 0 18px',height:50}}>
                        <div style={{width:8,height:8,borderRadius:'50%',background:'#ef4444',animation:'pulse-red 1s infinite'}}/>
                        <span style={{fontSize:13,color:'#ef4444',fontWeight:500}}>{fmtRecording(recordingTime)}</span>
                        <span style={{fontSize:12,color:'#aaa',flex:1}}>Grabando nota de voz...</span>
                        <button onClick={stopRecording} style={{padding:'5px 13px',borderRadius:999,border:'none',background:'#ef4444',color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>Enviar</button>
                        <button onClick={()=>{recordingCancelledRef.current=true;mediaRecorderRef.current?.stop();setRecording(false);clearInterval(recordingTimerRef.current);setRecordingTime(0);}} style={{padding:'5px 11px',borderRadius:999,border:'1px solid #e8e8e6',background:'#fff',fontSize:12,cursor:'pointer',fontFamily:'inherit'}}>Cancelar</button>
                      </div>
                    ) : (
                      <div className="chat-input-pill">
                        <input className="ci-input" placeholder="Escribe un mensaje..." value={msgInput} onChange={e=>setMsgInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMessage();}}}/>
                        <button className="ci-send" disabled={sending} onClick={()=>sendMessage()}>
                          {sending ? <div className="spinner" style={{width:14,height:14,borderTopColor:'#fff',borderColor:'rgba(255,255,255,0.3)'}}/> : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>}
                        </button>
                      </div>
                    )}

                    {/* Emoji picker floating panel */}
                    {showEmojiPicker && (
                      <div style={{position:'absolute',bottom:'100%',left:16,zIndex:500}} onClick={e=>e.stopPropagation()}>
                        <EmojiPicker data={emojiData} set="native" theme="light" locale="es"
                          onEmojiSelect={e=>{setMsgInput(p=>p+e.native);setShowEmojiPicker(false);}}
                        />
                      </div>
                    )}

                    {/* Toolbar below input */}
                    <div className="chat-toolbar">
                      <button className="toolbar-btn" onClick={()=>{setShowTemplates(true);loadMetaTemplates();}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
                        Template
                      </button>
                      <button className="toolbar-btn" onClick={e=>{e.stopPropagation();setShowEmojiPicker(v=>!v);}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>
                        Emoji
                      </button>
                      <button className="toolbar-btn" onClick={()=>fileInputRef.current?.click()}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                        Attach
                      </button>
                      <button className="toolbar-btn" onClick={recording ? stopRecording : startRecording} style={recording ? {color:'#ef4444'} : {}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={recording?'#ef4444':'#555'} strokeWidth="1.8" strokeLinecap="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                        Voice Message
                      </button>
                      <button className="toolbar-btn" onClick={()=>setShowFlows(true)} style={{color:'#9333ea'}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9333ea" strokeWidth="1.8" strokeLinecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                        Flujo
                      </button>
                      <button className="toolbar-btn shopify-btn" onClick={()=>{ if(shopifyOrders.length===0){alert('Este cliente no tiene pedidos en Shopify');return;} if(shopifyOrders.length===1){setSelectedOrder(shopifyOrders[0]);setShowOrderActions(true);}else{setShowOrderSelect(true);} }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                        Shopify
                      </button>
                      <span style={{marginLeft:'auto',fontSize:11,color:'#bbb',fontWeight:500,flexShrink:0}}>{msgInput.length}/1000</span>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="info-panel">
              <div className="ip-tabs">
                {['cliente','notas'].map(t=>(
                  <div key={t} className={`ip-tab${activeTab===t?' active':''}`} onClick={()=>setActiveTab(t)}>
                    {t==='cliente'?'Cliente':'Notas'}
                  </div>
                ))}
              </div>
              <div className="ip-body">
                {activeTab==='cliente' ? (
                  <>
                    <div style={{marginBottom:20}}>
                      <div className="ip-section-title">Datos del cliente</div>
                      {[['Nombre', shopifyContact?.nombre || conv?.contact_name || '—'],['Teléfono', shopifyContact?.telefono || conv?.contact_phone || '—'],['Ciudad', shopifyContact?.ciudad || '—'],['Dirección', shopifyContact?.direccion || '—']].map(([l,v])=>(
                        <div key={l} className="ip-row"><span className="ip-label">{l}</span><span className="ip-value" style={{fontSize:11}}>{v}</span></div>
                      ))}
                      {shopifyContact && <>
                        <div className="ip-row"><span className="ip-label">Segmento</span><span className={`seg-badge seg-${shopifyContact.segmento}`}>{shopifyContact.segmento}</span></div>
                        <div className="ip-row"><span className="ip-label">Pedidos</span><span className="ip-value" style={{fontWeight:700}}>{shopifyContact.pedidos}</span></div>
                        <div className="ip-row"><span className="ip-label">Valor total</span><span className="ip-value" style={{fontWeight:700,color:'#16a34a'}}>{fmtCOP(shopifyContact.valor)}</span></div>
                      </>}
                    </div>
                    {loadingOrders ? <div style={{display:'flex',justifyContent:'center',padding:16}}><div className="spinner"/></div>
                    : activeOrder ? (
                      <>
                        <div className="ip-section-title">Pedido activo</div>
                        <div className="order-card">
                          <div className="order-card-top">
                            <span className="order-num">{activeOrder.id}</span>
                            <span className={`order-status ${activeOrder.status==='Entregado'?'status-entregado':'status-pendiente'}`}>{activeOrder.status}</span>
                          </div>
                          <div className="order-product">{activeOrder.product}</div>
                          {activeOrder.variant && <div style={{fontSize:11,color:'#aaa'}}>{activeOrder.variant}</div>}
                          <div className="order-price">{fmtCOP(activeOrder.total)} · COD</div>
                          {activeOrder.guia && <div className="order-meta"><span style={{fontSize:11,color:'#888'}}>{activeOrder.transportadora}</span><span className="order-guia">{activeOrder.guia}</span></div>}
                        </div>
                        {novedades.length > 0 && (
                          <div style={{marginBottom:16}}>
                            <div className="ip-section-title" style={{marginBottom:10}}>Novedades {activeOrder.transportadora || 'Coordinadora'}</div>
                            {novedades.map((n,i)=>(
                              <div key={i} className="novedad-item">
                                <div className="novedad-dot" style={{background:NOVEDAD_COLORS[n.title]||'#888'}}/>
                                <div><div className="novedad-title" style={{color:NOVEDAD_COLORS[n.title]||'#0a0a0a'}}>{n.title}</div><div className="novedad-desc">{n.desc}</div><div className="novedad-time">{n.time}</div></div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    ) : shopifyContact ? <div style={{padding:'10px 12px',background:'#f8f8f6',borderRadius:10,fontSize:12,color:'#aaa',textAlign:'center',marginBottom:16}}>Sin pedidos activos</div> : null}
                    {pastOrders.length > 0 && (
                      <>
                        <div className="ip-section-title">Historial reciente</div>
                        {pastOrders.map(o=>(
                          <div key={o.id} className="hist-item">
                            <div><div style={{fontSize:12,fontWeight:700,color:'#0a0a0a'}}>{o.id}</div><div style={{fontSize:11,color:'#aaa'}}>{o.product}</div></div>
                            <div style={{fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:999,background:'#f0fdf4',color:'#16a34a'}}>{o.status}</div>
                          </div>
                        ))}
                      </>
                    )}
                    {!shopifyContact && conv && <div style={{padding:'10px 12px',background:'#f8f8f6',borderRadius:10,fontSize:12,color:'#aaa',textAlign:'center',marginTop:8}}>Cliente nuevo — sin historial en Shopify</div>}
                  </>
                ) : (
                  <div>
                    <div className="ip-section-title">Notas internas</div>
                    <div style={{display:'flex',flexDirection:'column',gap:9,marginBottom:14}}>
                      {notes.map(n=>(
                        <div key={n.id} style={{background:'#f6f6f4',borderRadius:10,padding:'11px 13px',borderLeft:'3px solid #bbf7d0'}}>
                          <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                            <span style={{fontSize:11,fontWeight:700,color:'#555'}}>{n.author}</span>
                            <span style={{fontSize:10,color:'#bbb'}}>{n.time}</span>
                          </div>
                          <div style={{fontSize:12,color:'#555',lineHeight:1.5}}>{n.text}</div>
                        </div>
                      ))}
                    </div>
                    <div className="note-input-wrap">
                      <textarea className="note-input" placeholder="Agregar nota interna..." value={noteInput} onChange={e=>setNoteInput(e.target.value)}/>
                      <button className="note-btn" onClick={()=>{if(!noteInput.trim())return;setNotes([...notes,{id:Date.now(),author:user?.name?.split(' ')[0]||'Daniel',text:noteInput,time:'ahora'}]);setNoteInput('');}}>Guardar nota</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
      </div>

      {showTemplates && (
        <div className="modal-overlay" onClick={()=>setShowTemplates(false)}>
          <div className="modal" style={{width:560}} onClick={e=>e.stopPropagation()}>
            <div className="modal-hdr"><div className="modal-title">Plantillas de mensaje</div><div className="modal-close" onClick={()=>setShowTemplates(false)}>×</div></div>
            <div style={{display:'flex',gap:4,marginBottom:14,flexShrink:0}}>
              {['meta','internas'].map(t=>(
                <button key={t} onClick={()=>setTemplateTab(t)} style={{padding:'6px 16px',borderRadius:8,border:'1px solid #e8e8e6',background:templateTab===t?'#0a0a0a':'#fff',color:templateTab===t?'#fff':'#555',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit'}}>
                  {t==='meta'?'Meta (aprobadas)':'Internas Talku'}
                </button>
              ))}
            </div>
            <div className="modal-search">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#bbb" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round"/></svg>
              <input placeholder="Buscar plantilla..." value={templateSearch} onChange={e=>setTemplateSearch(e.target.value)}/>
            </div>
            <div className="modal-scroll">
              {templateTab === 'meta' ? (
                metaTemplates.length === 0 ? <div style={{textAlign:'center',padding:32,color:'#bbb',fontSize:13}}>Cargando plantillas...</div>
                : metaTemplates.filter(t=>t.name?.toLowerCase().includes(templateSearch.toLowerCase())).map((t,i)=>(
                  <div key={i} className="tpl-item" onClick={()=>{sendMessage(t.components?.find(c=>c.type==='BODY')?.text || t.name);setShowTemplates(false);}}>
                    <div className="tpl-badge" style={{background:t.status==='APPROVED'?'#f0fdf4':'#fef9c3',color:t.status==='APPROVED'?'#16a34a':'#854d0e'}}>{t.status==='APPROVED'?'✓ Aprobada':'⏳ Pendiente'}</div>
                    <div className="tpl-name">{t.name}</div>
                    <div className="tpl-text">{t.components?.find(c=>c.type==='BODY')?.text?.substring(0,120)}...</div>
                  </div>
                ))
              ) : PLANTILLAS_INTERNAS.filter(p=>p.nombre.toLowerCase().includes(templateSearch.toLowerCase())).map(p=>(
                <div key={p.id} className="tpl-item" onClick={()=>{
                  const nombre = shopifyContact?.nombre || conv?.contact_name || 'cliente';
                  sendMessage(p.texto.replace('{nombre}',nombre).replace('{orden}',activeOrder?.id||'—').replace('{estado}',activeOrder?.status||'—'));
                  setShowTemplates(false);
                }}>
                  <div className="tpl-badge" style={{background:'#eff6ff',color:'#1d4ed8'}}>{p.categoria}</div>
                  <div className="tpl-name">{p.nombre}</div>
                  <div className="tpl-text">{p.texto.substring(0,100)}...</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showFlows && (
        <div className="modal-overlay" onClick={()=>{setShowFlows(false);setFlowStep('list');setSelectedFlow(null);setFlowResult(null);setFlowSearch('');}}>
          <div className="modal" style={{width:520}} onClick={e=>e.stopPropagation()}>

            {/* ── Paso 1: lista ── */}
            {flowStep === 'list' && (() => {
              const nombre = shopifyContact?.nombre || conv?.contact_name || 'cliente';
              const visibles = FLOWS_ACTIVOS.filter(f => {
                const matchEstado = flowFilterEstado === 'todos' || f.estado === flowFilterEstado;
                const matchSearch = !flowSearch || f.nombre.toLowerCase().includes(flowSearch.toLowerCase()) || f.tienda.toLowerCase().includes(flowSearch.toLowerCase());
                return matchEstado && matchSearch;
              });
              return (<>
                <div className="modal-hdr">
                  <div className="modal-title">Ejecutar flujo</div>
                  <div className="modal-close" onClick={()=>{setShowFlows(false);setFlowStep('list');setSelectedFlow(null);setFlowSearch('');}}>×</div>
                </div>
                <div style={{display:'flex',gap:8,marginBottom:12,flexShrink:0}}>
                  <input value={flowSearch} onChange={e=>setFlowSearch(e.target.value)} placeholder="Buscar flujo..." style={{flex:1,padding:'7px 11px',border:'1.5px solid #e4e4e2',borderRadius:8,fontSize:13,outline:'none',fontFamily:'inherit'}}/>
                  <select value={flowFilterEstado} onChange={e=>setFlowFilterEstado(e.target.value)} style={{padding:'7px 10px',border:'1.5px solid #e4e4e2',borderRadius:8,fontSize:12,outline:'none',fontFamily:'inherit',color:'#555',background:'#fff'}}>
                    <option value="activo">Solo activos</option>
                    <option value="todos">Todos</option>
                    <option value="inactivo">Inactivos</option>
                  </select>
                </div>
                <div className="modal-scroll">
                  {visibles.length === 0 && <div style={{textAlign:'center',padding:32,color:'#bbb',fontSize:13}}>No hay flujos que coincidan</div>}
                  {visibles.map(f => {
                    const msgPreview = f.mensaje.replace('{nombre}', nombre);
                    const tipoColor = FLOW_TIPO_COLOR[f.tipo] || '#888';
                    return (
                      <div key={f.id} className="flow-item" style={{opacity: f.estado==='inactivo'?0.55:1}} onClick={()=>{setSelectedFlow({...f, msgResuelto: msgPreview});setFlowStep('preview');setFlowResult(null);}}>
                        <div style={{width:36,height:36,borderRadius:10,background:`${tipoColor}18`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tipoColor} strokeWidth="1.8" strokeLinecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:2}}>
                            <span style={{fontSize:13,fontWeight:700,color:'#0a0a0a'}}>{f.nombre}</span>
                            <span style={{fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:999,background:`${tipoColor}18`,color:tipoColor,textTransform:'uppercase',letterSpacing:'0.04em'}}>{f.tipo}</span>
                            {f.estado==='inactivo' && <span style={{fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:999,background:'#f4f4f2',color:'#999'}}>inactivo</span>}
                          </div>
                          <div style={{fontSize:11,color:'#aaa',marginBottom:3}}>{f.tienda} · {f.ejecuciones.toLocaleString()} ejecuciones</div>
                          <div style={{fontSize:11,color:'#888',fontStyle:'italic',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>"{msgPreview.substring(0,65)}{msgPreview.length>65?'...':''}"</div>
                        </div>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
                      </div>
                    );
                  })}
                </div>
              </>);
            })()}

            {/* ── Paso 2: preview + confirmar ── */}
            {flowStep === 'preview' && selectedFlow && (() => {
              const tipoColor = FLOW_TIPO_COLOR[selectedFlow.tipo] || '#888';
              return (<>
                <div className="modal-hdr">
                  <button onClick={()=>{setFlowStep('list');setFlowResult(null);}} style={{background:'none',border:'none',cursor:'pointer',padding:'4px 8px 4px 0',color:'#555',fontSize:13,display:'flex',alignItems:'center',gap:4,fontFamily:'inherit'}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
                    Volver
                  </button>
                  <div className="modal-close" onClick={()=>{setShowFlows(false);setFlowStep('list');setSelectedFlow(null);setFlowResult(null);}}>×</div>
                </div>
                <div style={{marginBottom:16,flexShrink:0}}>
                  <div style={{display:'flex',alignItems:'center',gap:10,padding:'12px 14px',background:'#f8f8f6',borderRadius:12,border:'1px solid #e4e4e2',marginBottom:14}}>
                    <div style={{width:38,height:38,borderRadius:10,background:`${tipoColor}18`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={tipoColor} strokeWidth="1.8" strokeLinecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                    </div>
                    <div>
                      <div style={{fontSize:14,fontWeight:700,color:'#0a0a0a'}}>{selectedFlow.nombre}</div>
                      <div style={{fontSize:11,color:'#aaa',marginTop:1}}>{selectedFlow.tienda} · <span style={{color:tipoColor,fontWeight:700}}>{selectedFlow.tipo}</span></div>
                    </div>
                  </div>
                  <div style={{fontSize:11,fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:8}}>Mensaje que se enviará</div>
                  <div style={{background:'#F1F3F4',borderRadius:12,padding:'14px 16px',fontSize:14,lineHeight:1.7,color:'#0a0a0a',whiteSpace:'pre-wrap'}}>{selectedFlow.msgResuelto}</div>
                  <div style={{fontSize:11,color:'#aaa',marginTop:8}}>→ Se enviará a <strong>{conv?.contact_name || conv?.contact_phone}</strong> ({conv?.contact_phone})</div>
                </div>
                {flowResult === 'ok' && (
                  <div style={{display:'flex',alignItems:'center',gap:8,padding:'10px 14px',background:'#f0fdf4',borderRadius:10,border:'1px solid #bbf7d0',marginBottom:12}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    <span style={{fontSize:13,color:'#16a34a',fontWeight:500}}>Flujo ejecutado correctamente</span>
                  </div>
                )}
                {flowResult === 'error' && (
                  <div style={{display:'flex',alignItems:'center',gap:8,padding:'10px 14px',background:'#fef2f2',borderRadius:10,border:'1px solid #fecaca',marginBottom:12}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="0.5" fill="#ef4444"/></svg>
                    <span style={{fontSize:13,color:'#ef4444',fontWeight:500}}>Error al enviar el mensaje</span>
                  </div>
                )}
                <div style={{display:'flex',gap:10,flexShrink:0}}>
                  <button onClick={()=>{setShowFlows(false);setFlowStep('list');setSelectedFlow(null);setFlowResult(null);}} style={{flex:1,padding:'11px 0',borderRadius:10,border:'1.5px solid #e4e4e2',background:'#fff',fontSize:13,fontWeight:500,cursor:'pointer',fontFamily:'inherit',color:'#555'}}>Cancelar</button>
                  <button disabled={flowSending || flowResult==='ok'} onClick={async()=>{
                    setFlowSending(true);
                    setFlowResult(null);
                    try {
                      await sendMessage(selectedFlow.msgResuelto);
                      setFlowResult('ok');
                      setTimeout(()=>{setShowFlows(false);setFlowStep('list');setSelectedFlow(null);setFlowResult(null);}, 1400);
                    } catch(e) { setFlowResult('error'); }
                    setFlowSending(false);
                  }} style={{flex:2,padding:'11px 0',borderRadius:10,border:'none',background:flowResult==='ok'?'#16a34a':flowSending?'#555':'#0a0a0a',color:'#fff',fontSize:13,fontWeight:700,cursor:flowSending||flowResult==='ok'?'not-allowed':'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',justifyContent:'center',gap:8,transition:'background 0.15s'}}>
                    {flowSending ? <><div className="spinner" style={{width:13,height:13,borderTopColor:'#fff',borderColor:'rgba(255,255,255,0.3)'}}/> Enviando...</> : flowResult==='ok' ? '✓ Enviado' : <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg> Ejecutar flujo</>}
                  </button>
                </div>
              </>);
            })()}

          </div>
        </div>
      )}

      {showOrderSelect && (
        <div className="modal-overlay" onClick={()=>setShowOrderSelect(false)}>
          <div className="modal" style={{width:480}} onClick={e=>e.stopPropagation()}>
            <div className="modal-hdr"><div className="modal-title">Seleccionar pedido</div><div className="modal-close" onClick={()=>setShowOrderSelect(false)}>×</div></div>
            <div style={{fontSize:12,color:'#aaa',marginBottom:14}}>Este cliente tiene {shopifyOrders.length} pedidos. ¿Cuál deseas modificar?</div>
            <div className="modal-scroll">
              {shopifyOrders.map(o=>(
                <div key={o.shopify_id} onClick={()=>{setSelectedOrder(o);setShowOrderSelect(false);setShowOrderActions(true);setActionMsg('');}} style={{padding:'14px 16px',border:'1px solid #e8e8e6',borderRadius:12,marginBottom:8,cursor:'pointer',transition:'all 0.15s',opacity:isOrderEditable(o)?1:0.6}} onMouseEnter={e=>e.currentTarget.style.borderColor='#0a0a0a'} onMouseLeave={e=>e.currentTarget.style.borderColor='#e8e8e6'}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
                    <span style={{fontSize:14,fontWeight:700,color:'#0a0a0a'}}>{o.id}</span>
                    <div style={{display:'flex',gap:6,alignItems:'center'}}>
                      {!isOrderEditable(o) && <span style={{fontSize:10,color:'#aaa'}}>No modificable</span>}
                      <span className={`order-status ${o.status==='Entregado'?'status-entregado':'status-pendiente'}`}>{o.status}</span>
                    </div>
                  </div>
                  <div style={{fontSize:12,color:'#555',marginBottom:4}}>{o.product}{o.variant?` · ${o.variant}`:''}</div>
                  <div style={{display:'flex',justifyContent:'space-between'}}>
                    <span style={{fontSize:12,fontWeight:700,color:'#0a0a0a'}}>{fmtCOP(o.total)}</span>
                    <span style={{fontSize:11,color:'#bbb'}}>{o.date ? new Date(o.date).toLocaleDateString('es-CO',{day:'2-digit',month:'short',year:'numeric'}) : '—'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showOrderActions && selectedOrder && (
        <div className="modal-overlay" onClick={()=>{setShowOrderActions(false);setActionMsg('');setShopifyNoteInput('');setShopifyTagInput('');}}>
          <div className="modal" style={{width:440}} onClick={e=>e.stopPropagation()}>
            <div className="modal-hdr">
              <div><div className="modal-title">Acciones — {selectedOrder.id}</div><div style={{fontSize:12,color:'#aaa',marginTop:3}}>{selectedOrder.product} · {fmtCOP(selectedOrder.total)}</div></div>
              <div className="modal-close" onClick={()=>{setShowOrderActions(false);setActionMsg('');setShopifyNoteInput('');setShopifyTagInput('');}}>×</div>
            </div>
            {!isOrderEditable(selectedOrder) && <div style={{background:'#fef9c3',border:'1px solid #fde68a',borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:12,color:'#92400e'}}>⚠️ Este pedido ya fue preparado/entregado. Solo puedes agregar notas o etiquetas.</div>}
            {actionMsg && <div style={{background:actionMsg.includes('✅')?'#f0fdf4':'#fef2f2',border:`1px solid ${actionMsg.includes('✅')?'#bbf7d0':'#fee2e2'}`,borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:13,color:actionMsg.includes('✅')?'#16a34a':'#ef4444'}}>{actionMsg}</div>}
            <div className="modal-scroll">
              <button className={`action-btn${!isOrderEditable(selectedOrder)?' disabled':''}`} disabled={!isOrderEditable(selectedOrder)||actionLoading} onClick={()=>shopifyAction('fulfill',selectedOrder.shopify_id)}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                <div><div style={{fontWeight:700,color:isOrderEditable(selectedOrder)?'#0a0a0a':'#aaa'}}>Preparar pedido</div><div style={{fontSize:11,color:'#aaa',marginTop:1}}>Marca como fulfillment completado en Shopify</div></div>
                {actionLoading && <div className="spinner" style={{marginLeft:'auto'}}/>}
              </button>
              <button className={`action-btn${selectedOrder.financial_status==='paid'?' disabled':''}`} disabled={selectedOrder.financial_status==='paid'||actionLoading} onClick={()=>shopifyAction('mark-paid',selectedOrder.shopify_id)}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-4"/></svg>
                <div><div style={{fontWeight:700,color:selectedOrder.financial_status==='paid'?'#aaa':'#0a0a0a'}}>Marcar como pagado</div><div style={{fontSize:11,color:'#aaa',marginTop:1}}>{selectedOrder.financial_status==='paid'?'Ya está pagado':'Registra el pago en Shopify'}</div></div>
              </button>
              <div style={{border:'1px solid #e8e8e6',borderRadius:10,padding:'12px 14px',marginBottom:8}}>
                <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:8}}>Agregar nota</div>
                {selectedOrder.note && <div style={{fontSize:11,color:'#aaa',marginBottom:6,fontStyle:'italic'}}>Nota actual: "{selectedOrder.note}"</div>}
                <textarea value={shopifyNoteInput} onChange={e=>setShopifyNoteInput(e.target.value)} placeholder="Escribe la nota..." style={{width:'100%',padding:'8px 10px',border:'1px solid #e8e8e6',borderRadius:8,fontSize:12,fontFamily:'inherit',outline:'none',resize:'none',height:60}}/>
                <button disabled={!shopifyNoteInput.trim()||actionLoading} onClick={()=>shopifyAction('note',selectedOrder.shopify_id,{note:shopifyNoteInput}).then(()=>setShopifyNoteInput(''))} style={{marginTop:6,padding:'6px 14px',borderRadius:8,border:'none',background:shopifyNoteInput.trim()?'#0a0a0a':'#e8e8e6',color:shopifyNoteInput.trim()?'#fff':'#aaa',fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>Guardar</button>
              </div>
              <div style={{border:'1px solid #e8e8e6',borderRadius:10,padding:'12px 14px',marginBottom:8}}>
                <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:8}}>Agregar etiqueta</div>
                {selectedOrder.tags && <div style={{fontSize:11,color:'#aaa',marginBottom:6}}>Etiquetas: {selectedOrder.tags}</div>}
                <input value={shopifyTagInput} onChange={e=>setShopifyTagInput(e.target.value)} placeholder="ej: urgente, cambio-talla" style={{width:'100%',padding:'8px 10px',border:'1px solid #e8e8e6',borderRadius:8,fontSize:12,fontFamily:'inherit',outline:'none'}}/>
                <button disabled={!shopifyTagInput.trim()||actionLoading} onClick={()=>shopifyAction('tags',selectedOrder.shopify_id,{tags:shopifyTagInput}).then(()=>setShopifyTagInput(''))} style={{marginTop:6,padding:'6px 14px',borderRadius:8,border:'none',background:shopifyTagInput.trim()?'#0a0a0a':'#e8e8e6',color:shopifyTagInput.trim()?'#fff':'#aaa',fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>Agregar</button>
              </div>
              <button className={`action-btn danger${!isOrderEditable(selectedOrder)?' disabled':''}`} disabled={!isOrderEditable(selectedOrder)||actionLoading} onClick={()=>{if(window.confirm(`¿Cancelar ${selectedOrder.id}? Esta acción no se puede deshacer.`))shopifyAction('cancel',selectedOrder.shopify_id);}}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                <div><div style={{fontWeight:700}}>Cancelar pedido</div><div style={{fontSize:11,color:'#ef4444',marginTop:1,opacity:0.8}}>Acción irreversible</div></div>
              </button>
              <button className="action-btn" onClick={()=>storeDomain && window.open(`https://${storeDomain}/admin/orders/new`,'_blank')}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                <div><div style={{fontWeight:700}}>Crear nuevo pedido</div><div style={{fontSize:11,color:'#aaa',marginTop:1}}>Abre Shopify Admin</div></div>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" style={{marginLeft:'auto'}}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {showAssign && (
        <div className="modal-overlay" onClick={()=>setShowAssign(false)}>
          <div className="modal" style={{width:380}} onClick={e=>e.stopPropagation()}>
            <div className="modal-hdr"><div className="modal-title">Asignar agente</div><div className="modal-close" onClick={()=>setShowAssign(false)}>×</div></div>
            <div style={{fontSize:12,color:'#aaa',marginBottom:14}}>Asigna esta conversación a un agente del equipo</div>
            {AGENTES.map(a=>(
              <div key={a} onClick={()=>{setAssignedAgent(p=>({...p,[activeConv]:a}));setShowAssign(false);}} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',borderRadius:12,border:`1px solid ${assignedAgent[activeConv]===a?'#0a0a0a':'#e8e8e6'}`,marginBottom:8,cursor:'pointer',background:assignedAgent[activeConv]===a?'#f4f4f2':'#fff',transition:'all 0.15s'}}>
                <div style={{width:36,height:36,borderRadius:50,background:AVATAR_COLORS[AGENTES.indexOf(a)%AVATAR_COLORS.length],display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'#555'}}>{initials(a)}</div>
                <span style={{fontSize:13,fontWeight:500,color:'#0a0a0a'}}>{a}</span>
                {assignedAgent[activeConv]===a && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="2.5" strokeLinecap="round" style={{marginLeft:'auto'}}><polyline points="20 6 9 17 4 12"/></svg>}
              </div>
            ))}
          </div>
        </div>
      )}

      {showCallIA && (
        <div className="modal-overlay" onClick={()=>setShowCallIA(false)}>
          <div className="modal" style={{width:440}} onClick={e=>e.stopPropagation()}>
            <div className="modal-hdr"><div className="modal-title">Llamar con IA · Zadarma</div><div className="modal-close" onClick={()=>setShowCallIA(false)}>×</div></div>
            <div style={{fontSize:12,color:'#aaa',marginBottom:16}}>Selecciona el tipo de llamada que la IA realizará</div>
            {[
              { tipo:'Confirmación de pedido', desc:'La IA confirma datos del pedido y dirección de entrega', icon:'📦' },
              { tipo:'Recuperación de carrito', desc:'La IA intenta recuperar al cliente que no completó su compra', icon:'🛒' },
              { tipo:'Novedad de entrega', desc:'La IA informa sobre una novedad en la entrega y solicita corrección', icon:'🚚' },
              { tipo:'Encuesta de satisfacción', desc:'La IA solicita feedback sobre el pedido recibido', icon:'⭐' },
              { tipo:'Cobranza COD', desc:'La IA gestiona el cobro de un pedido contra entrega pendiente', icon:'💰' },
            ].map((t,i)=>(
              <div key={i} onClick={()=>{alert(`Llamada IA "${t.tipo}" a ${conv?.contact_phone}.\n\nIntegración con Zadarma pendiente.`);setShowCallIA(false);}} style={{display:'flex',alignItems:'flex-start',gap:12,padding:'12px 14px',borderRadius:12,border:'1px solid #e8e8e6',marginBottom:8,cursor:'pointer',transition:'all 0.15s'}} onMouseEnter={e=>{e.currentTarget.style.borderColor='#0a0a0a';e.currentTarget.style.background='#f8f8f6';}} onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8e8e6';e.currentTarget.style.background='#fff';}}>
                <span style={{fontSize:24,flexShrink:0}}>{t.icon}</span>
                <div><div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:3}}>{t.tipo}</div><div style={{fontSize:11,color:'#aaa',lineHeight:1.5}}>{t.desc}</div></div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" style={{marginLeft:'auto',flexShrink:0,marginTop:2}}><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            ))}
            <div style={{marginTop:8,padding:'10px 12px',background:'#fffbeb',border:'1px solid #fde68a',borderRadius:10,fontSize:11,color:'#92400e'}}>
              ⚠️ La integración con Zadarma requiere configurar las credenciales API en el panel de configuración.
            </div>
          </div>
        </div>
      )}

      {imgModal && (
        <div onClick={()=>setImgModal(null)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',cursor:'zoom-out'}}>
          {imgModal?.type === 'video' ?
            <video controls autoPlay src={imgModal.url} style={{maxWidth:'90vw',maxHeight:'90vh',borderRadius:12}} onClick={e=>e.stopPropagation()} /> :
            <img src={typeof imgModal === 'string' ? imgModal : imgModal?.url} alt="preview" style={{maxWidth:'90vw',maxHeight:'90vh',borderRadius:12,objectFit:'contain'}} onClick={e=>e.stopPropagation()} />
          }
          <div onClick={()=>setImgModal(null)} style={{position:'absolute',top:20,right:24,width:40,height:40,borderRadius:'50%',background:'rgba(255,255,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:22,color:'#fff',fontWeight:300}}>×</div>
        </div>
      )}

      {/* Toast notifications */}
      <style>{`
        @keyframes toastIn {
          from { transform: translateX(-110%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        @keyframes toastOut {
          from { transform: translateX(0);    opacity: 1; }
          to   { transform: translateX(-110%); opacity: 0; }
        }
      `}</style>
      <div style={{position:'fixed',bottom:24,left:24,zIndex:9999,display:'flex',flexDirection:'column',gap:10,pointerEvents:'none'}}>
        {notifications.slice(-4).map(n => {
          const isOut = exitingNotifs.has(n.id);
          const avatarColor = AVATAR_COLORS[(n.convId || 0) % AVATAR_COLORS.length];
          return (
            <div key={n.id} style={{
              width:340,background:'#fff',borderRadius:18,
              boxShadow:'0 12px 48px rgba(0,0,0,0.14),0 2px 8px rgba(0,0,0,0.06)',
              padding:'14px 16px 14px 14px',pointerEvents:'all',
              animation:`${isOut?'toastOut 0.35s cubic-bezier(0.4,0,1,1)':'toastIn 0.42s cubic-bezier(0.16,1,0.3,1)'} forwards`,
            }}>
              {/* Header */}
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:9}}>
                <div style={{position:'relative',flexShrink:0}}>
                  <div style={{width:40,height:40,borderRadius:'50%',background:avatarColor,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:700,color:'#fff',letterSpacing:0.5}}>
                    {initials(n.contactName)}
                  </div>
                  <div style={{position:'absolute',bottom:1,right:1,width:10,height:10,borderRadius:'50%',background:'#22c55e',border:'2px solid #fff'}}/>
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',lineHeight:1.2,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{n.contactName}</div>
                  <div style={{fontSize:11,color:'#aaa',marginTop:2}}>{fmtTime(n.timestamp)}</div>
                </div>
                <button onClick={()=>dismissNotification(n.id)} style={{background:'none',border:'none',cursor:'pointer',color:'#c0c0c0',padding:'2px 4px',fontSize:19,lineHeight:1,flexShrink:0,borderRadius:6,transition:'color 0.15s'}}
                  onMouseEnter={e=>e.target.style.color='#888'} onMouseLeave={e=>e.target.style.color='#c0c0c0'}>×</button>
              </div>
              {/* Message */}
              <div style={{fontSize:13,color:'#555',lineHeight:1.55,marginBottom:12,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical'}}>
                {n.message}
              </div>
              {/* Buttons */}
              <div style={{display:'flex',gap:8}}>
                <button onClick={()=>dismissNotification(n.id)} style={{flex:1,padding:'8px 0',borderRadius:10,border:'1.5px solid #e4e4e4',background:'#fff',color:'#555',fontSize:13,fontWeight:500,cursor:'pointer',transition:'background 0.15s'}}
                  onMouseEnter={e=>e.target.style.background='#f5f5f5'} onMouseLeave={e=>e.target.style.background='#fff'}>
                  Dismiss
                </button>
                <button onClick={()=>replyNotification(n)} style={{flex:1,padding:'8px 0',borderRadius:10,border:'none',background:'#4f46e5',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',transition:'background 0.15s'}}
                  onMouseEnter={e=>e.target.style.background='#4338ca'} onMouseLeave={e=>e.target.style.background='#4f46e5'}>
                  Reply
                </button>
              </div>
            </div>
          );
        })}
      </div>

    </>
  );
}